import React, {useState, useLayoutEffect, useContext, useEffect, useRef, useCallback, memo, createRef} from 'react';
import SystemContext from "../../SystemContext";
import {useQueryClient} from "react-query";
import moment from "moment";
import __ from "lodash";
import axios from "axios";
import TimeWindow from "./TimeWindow";
import { getApiSitePrefix } from "../../functions/SiteDefaults";
import {useSchedulingScratchPads, useUpdateSchedulingScratchPad} from '../../services/flightPlanning';
import {useUpdateUserSetting} from '../../services/settings';
import {fetch as fetchDefaultServiceTypes} from "../../services/settings/useAirportServiceTypes";
import {fetch as fetchTripLegServices} from "../../services/trips/useTripLegServices";
import dialogs,
{ EditCrewDialog,
  EditPaxDialog,
  EditServicesDialog,
  EditCateringDialog,
  EditTripDialog,
} from "../../modules/Trips/components/TripListDialogs";
import editScheduledTripPlanningDialog from '../../modules/Trips/components/ScheduledTripListDialogs/EditScheduledTripPlanningDialog';
import { v4 as uuidv4 } from 'uuid';
import {fetch as fetchAirportTimings} from "../../services/airports/useAirportTimings";
import ContextMenus from './ContextMenus';
import { useUpdateTripLeg } from '../../services/trips';
import AircraftMovementCaptureDialog from '../../modules/Aircraft/components/AircraftMovementCaptureDialog';
import AircraftFuelLogDialog from '../../modules/Aircraft/components/AircraftFuelLogDialog';
import EditCargoDialog from '../../modules/Trips/components/TripListDialogs/EditCargoDialog';
import EditUldStacksDialog from '../../modules/Trips/components/TripListDialogs/EditUldStacksDialog';
import EditTripLegStdDialog from '../../modules/Trips/components/TripListDialogs/EditTripLegStdDialog';
import EditFlightDocumentsDialog from '../../modules/Flights/components/EditFlightDocumentsDialog';
import TripLegsActualWeightDialog from '../../modules/Trips/components/TripListDialogs/TripLegsActualWeightDialog';
import TripLegsNoteDialog from '../../modules/Trips/components/TripListDialogs/TripLegNotesDialog';
import TripLegChecklistItemDialog from '../../modules/Trips/components/TripListDialogs/TripLegChecklistItemDialog';
import TripLegEventDialog from '../../modules/Trips/components/TripListDialogs/TripLegEventDialog';
import TripLegDiversionDialog from '../../modules/Trips/components/TripListDialogs/TripLegDiversionDialog';
import TripLegReturnToStandDialog from '../../modules/Trips/components/TripListDialogs/TripLegReturnToStandDialog';
import FuelPolicyDialog from '../../modules/Fuel/components/FuelOrderDialogs/FuelPolicyDialog';
import useSaveTripLegServices from '../../services/trips/useSaveTripLegServices';
import { useAuth0 } from "@auth0/auth0-react";
import RefreshCheck from './RefreshCheck';
import { useUpdateFlight } from '../../services/flights';
import ViewBooking from '../../modules/Booking/components/ViewBooking';
import EditFlightMessagesDialog from '../../modules/Flights/components/EditFlightMessagesDialog';
import {useSettings} from "../../services/settings";
import { useTheme } from '@material-ui/core';

const AccessControl = require ("../../AccessControl");
const apiSitePrefix = getApiSitePrefix();
const ViewUldDocumentsDialog = EditFlightDocumentsDialog;
const ViewUldMessagesDialog = EditFlightMessagesDialog;

const formatChars={
  "U": "[A-Z]",
  "A": "[A-Z0-9]",
  "a": "[A-Za-z0-9]",
  "i": "[A-Za-z0-9\\-]",
  "9": "[0-9]",
  "D": "[0-9.]",
  "-": "-",
  "x": "."
}

const blockSizes = [50,25,12,6,3];
const offsets = {'50': 40, '25': 65, '12': 75, '6': 57, '3': 62};

const monthsTripData = {};
const monthsMxData = {};

const requestMonthsTripData = (startDate, force, monthKey, refreshing) => {
  const {status, queue, data} = monthsTripData[monthKey];

  if (status === 'RECEIVED' && !force) {
    while (queue.length > 0) {
      const {resolve} = queue.shift();
      resolve(data);
    }
  }

  const refreshParam = refreshing?'?refreshing=true':'';

  if (status === '' || status === 'FAILED' || force) {
    monthsTripData[monthKey].status = "FETCHING";
    axios.get(`${apiSitePrefix}/flightplanning/triplegs/${moment.utc(startDate).startOf('month').format('YYYY-MM-DD HH:mm:ss')}/${moment.utc(startDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')}${refreshParam}`)
      .then((data) => {
        if (monthsTripData && monthsTripData[monthKey]) {
          monthsTripData[monthKey].data = data;
          monthsTripData[monthKey].status = "RECEIVED";
        }
        while (queue.length > 0) {
          const {resolve} = queue.shift();
          resolve(data);
        }
      })
      .catch(err => {
        if (monthsTripData && monthsTripData[monthKey])
          monthsTripData[monthKey].status = "FAILED";
        while (queue.length > 0) {
          const {reject} = queue.shift();
          reject(err);
        }
      })
  }
}

const getMonthsTripData = async (startDate, force, refreshing) => {
  const monthKey = moment.utc(startDate).format('YYYYMM');
  if (!monthsTripData[monthKey]) {
    monthsTripData[monthKey] = {status: '', queue: [], data:null};
  }
  const requestPromise = new Promise((resolve, reject) => {
    monthsTripData[monthKey].queue.push({resolve,reject});
  });
  requestMonthsTripData(startDate, force, monthKey, refreshing);
  return requestPromise;
}

const requestMonthsMxData = (startDate, force, monthKey) => {
  const {status, queue, data} = monthsMxData[monthKey];

  if (status === 'RECEIVED' && !force) {
    while (queue.length > 0) {
      const {resolve} = queue.shift();
      resolve(data);
    }
  }

  if (status === '' || status === 'FAILED' || force) {
    monthsMxData[monthKey].status = "FETCHING";
    axios.get(`${apiSitePrefix}/scheduledMaintenance/list/${moment.utc(startDate).startOf('month').format('YYYY-MM-DD HH:mm:ss')}/${moment.utc(startDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')}`)
      .then((data) => {
        monthsMxData[monthKey].data = data;
        monthsMxData[monthKey].status = "RECEIVED";
        while (queue.length > 0) {
          const {resolve} = queue.shift();
          resolve(data);
        }
      })
      .catch(err => {
        if (monthsMxData[monthKey]) monthsMxData[monthKey].status = "FAILED";
        while (queue.length > 0) {
          const {reject} = queue.shift();
          reject(err);
        }
      })
  }
}

const getMonthsMxData = async (startDate, force) => {
  const monthKey = moment.utc(startDate).format('YYYYMM');
  if (!monthsMxData[monthKey]) {
    monthsMxData[monthKey] = {status: '', queue: [], data:null};
  }
  const requestPromise = new Promise((resolve, reject) => {
    monthsMxData[monthKey].queue.push({resolve,reject});
  });
  requestMonthsMxData(startDate, force, monthKey);
  return requestPromise;
}

const refreshLegData = async (uuid) => {
  const response = await axios.get(`${apiSitePrefix}/flightplanning/tripleg/${uuid}`);
  if (!response || !response.data || !response.data.startTime) return;
  const data = response.data;
  const monthKey = moment.utc(data.startTime).format('YYYYMM');
  const monthData = monthsTripData[monthKey];
  if (!monthData || !monthData.data || !monthData.data.data || !monthData.data.data.flights) return;
  const flights = data.flights;
  const aircraftRecords = Object.entries(flights);
  aircraftRecords.forEach(([aircraftReg, flights]) => {
    flights.forEach(tripLeg => {
      const uuid = tripLeg.uuid;
      const aircraftData = monthData.data.data.flights[aircraftReg];
      const idx = __.findIndex(aircraftData, {uuid});
      if (idx >=0) {
        aircraftData[idx] = tripLeg;
      }
    })
  })
}

const emptyCache = () => {
  console.log('Emptying Cache');
  const monthTripKeys = Object.keys(monthsTripData);
  monthTripKeys.forEach(monthKey => {
    delete monthsTripData[monthKey];
  })
  const monthMxKeys = Object.keys(monthsMxData);
  monthMxKeys.forEach(monthKey => {
    delete monthsMxData[monthKey];
  })
}

const RouteView = (props) => {
//  console.log('RouteView ')
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const eventBus = SystemData.eventBus;
  const { user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage TRIPS"]);
  const queryClient = useQueryClient();
  const handleUpdateTripLeg = useUpdateTripLeg();
  const handleSaveServices = useSaveTripLegServices();

  const classes = props.classes;
  const {
   TripContextMenu,
   openTripContextMenu,
   MxContextMenu,
   openMxContextMenu
  } = ContextMenus();

  const handleUpdateUserSetting = useUpdateUserSetting();
  const handleUpdateFlight = useUpdateFlight();

  const uldDocumentSettings = useSettings({queryClient, extraKeys: ["VIEW DOCUMENT TYPES", "ULD STOCK"]});
  const uldMessageSettings = useSettings({queryClient, extraKeys: ["VIEW MESSAGE TYPES", "ULD STOCK"]});

  const uldDocuments = (uldDocumentSettings?.data||[]).length > 0 && Array.isArray(uldDocumentSettings?.data[0].value)?uldDocumentSettings?.data[0].value:[];
  const uldMessages = (uldMessageSettings?.data||[]).length > 0 && Array.isArray(uldMessageSettings?.data[0].value)?uldMessageSettings?.data[0].value:[];

  const flags = useRef({
    initialized: false,
    startDateSet: false,
    dataLoaded: 0
  });
  const [state, setState] = useState({
    startDate: null,
    startTime: null,
    endTime: null,
    tripNo: null,
    blockSize: props.blockSize||25,
    clientWidth: 0,
    scrollLeft: -1,
    initialized: false,
    dataLoaded: 0,
    aircraftTrips: [],
    aircraftMx: [],
    scratchPadUser: props.scratchPadUser,
    scratchPad: props.scratchPad,
    deltas: {
      hasChanges: false,
      added: {trips: [], scheduled: [], maintenance: []},
      deleted: {trips: [], scheduled: [], maintenance: []},
      updated: {trips: [], scheduled: [], maintenance: []},
    },
    deltaErrors: [],
    multiSelect: null,
    selectedTripLegKey: null,
  });

  const [captureMovementDialog, setCaptureMovementDialog] = useState({
    captureMovement: false,
    aircraft: "",
    airlineCode: "",
    flightNo: "",
    originAirportCode: "",
    destinationAirportCode: ""
  });

  const [aircraftFuelLogDialogProps, setAircraftFuelLogDialogProps] = useState({
    open: false
  });

  const [defaultValues, setDefaultValues] = useState(null);

  const tooltipState = useRef({open: false, uuid: null, selectedScreen: "map"});

  const getTripSheetDefaultValues = async () => {
    try {
      const response = await axios.get(`${apiSitePrefix}/tripsheet/defaults`);
      if (response.data && response.data.success) {
        setDefaultValues(response.data.defaultValues);
        return response.data.defaultValues;
      }
      if (!response.data) {
        console.log(`Could not retrieve Trip sheet Defaults. Server is not responding`);
        SystemData.alert("Error", `Could not retrieve Trips sheet Defaults. Server is not responding`);
      } else if (!response.data.success) {
        console.log(`Could not retrieve Trips' Defaults. Server returned ${response.data.error}`);
        SystemData.alert("Error", `Could not retrieve Trips sheet Defaults. Server returned ${response.data.error}`);
      }
    } catch (err) {
      console.log(`Could not retrieve Trips sheet Defaults. Server is not responding`);
      SystemData.alert("Error", `Could not retrieve Trips sheet Defaults. Server is not responding`);
    }
  }

  const handleFuelLogDialogChange = (event) => {
    if (event.state === "cancel" || event.state === "save") {
      setAircraftFuelLogDialogProps ({
        ...aircraftFuelLogDialogProps,
        open: false,
      });
      eventBus.trigger('RouteView.pause', false);
    }
  }

  const getTripLegs = (tripUuid, deltas) => {
    let tripLegs = [];
    Object.keys(monthsTripData).forEach(monthKey => {
      if (Array.isArray(Object.keys(monthsTripData[monthKey]?.data?.data?.flights))){
        Object.keys(monthsTripData[monthKey].data.data.flights).forEach(aircraftKey => {
          monthsTripData[monthKey].data.data.flights[aircraftKey].forEach(trip => {
            if (trip.tripUuid === tripUuid) {
              let tripLeg = trip;
              let idx = __.findIndex(deltas.updated.trips, {uuid: trip.uuid});
              if (idx >= 0) {
                tripLeg = deltas.updated.trips[idx];
              }
              if (tripLeg.tripState !== "DELETED" && tripLeg.tripState !== "CANCELLED") {
                tripLegs.push(tripLeg);
              }
            }
          })
        })
      }
    });
    __.filter(deltas.updated.trips, {new:true, tripUuid}).forEach((leg) => {if (leg.tripState !== "DELETED" && leg.tripState !== "CANCELLED") tripLegs.push(leg)});
    tripLegs = __.sortBy(tripLegs, tripLeg => moment.utc(tripLeg.scheduledDepartureTimeUtc).toISOString());
    return tripLegs;
  }

  const setSetting = (changes) => {
    if (props.userSetting) {
      const oldRecord = props.userSetting;
      const oldValues = oldRecord.values;
      const newValues = {...oldValues, ...changes};
      handleUpdateUserSetting.mutate({extraKeys:['FLIGHT PLANNING', 'LAST VIEW STATE'], record: {...oldRecord, values: newValues}, oldRecord});
    }
  }

  const getAircraftTrips = (aircraftReg, deltas) => {
    let aircraftTrips = [];
    Object.keys(monthsTripData).forEach(monthKey => {
      if (Array.isArray(Object.keys(monthsTripData[monthKey]?.data?.data?.flights)) && Array.isArray(monthsTripData[monthKey].data.data.flights[aircraftReg])){
        monthsTripData[monthKey].data.data.flights[aircraftReg].forEach(trip => {
          aircraftTrips.push(trip);
        })
      }
    });
    Object.keys(__.omit(deltas, ['hasChanges'])).forEach(updateMode => {
      Object.keys(deltas[updateMode]).forEach(recordType => {
        deltas[updateMode][recordType].forEach(trip => {
          const idx = __.findIndex(aircraftTrips, {uuid: trip.uuid});
          if (idx >= 0) {
            if (trip.aircraftReg === aircraftReg && trip.tripState !== 'DELETED' && trip.tripState !== 'CANCELLED') {
              aircraftTrips[idx]=trip;
            } else {
              aircraftTrips.splice(idx, 1);
            }
          } else {
            if (trip.aircraftReg === aircraftReg) {
              if (trip.tripState !== 'DELETED' && trip.tripState !== 'CANCELLED') aircraftTrips.push(trip);
            }
          }
        })
      })
    });

    aircraftTrips = __.sortBy(aircraftTrips, tripLeg => moment.utc(tripLeg.scheduledDepartureTimeUtc).toISOString());
    return aircraftTrips;
  }

  const validateDeltas = useCallback((deltas) => {
    const deltaErrors = {};
    let tripUuids = [];
    const trips = [];
    const aircraftTrips = {};

    const validateTrip = (tripLegs, aircraftTrips) => {
      const errors = {};
      const addError = (key, error) => {
        if (!__.has(errors, key)) errors[key] = [];
        errors[key].push(error);
      }
      tripLegs.forEach((tripLeg, i) => {
        if (i > 0) {
          if (tripLeg.originAirportCode !== tripLegs[i - 1].destinationAirportCode) {
            addError(tripLeg.uuid,'Origin does not match previous legs destination');
          }
          if (moment.utc(tripLeg.scheduledDepartureTimeUtc).isBefore(moment.utc(tripLegs[i - 1].scheduledArrivalTimeUtc))) {
            addError(tripLeg.uuid,'Departure is prior to arrival of previous leg');
          }
        }
        if (i === 0 || tripLeg.aircraftReg !== tripLegs[i - 1].aircraftReg) {
          if (!__.has(aircraftTrips, tripLeg.aircraftReg)) {
            aircraftTrips[tripLeg.aircraftReg] = getAircraftTrips(tripLeg.aircraftReg);
          }
          const acTrips = aircraftTrips[tripLeg.aircraftReg];
          if (acTrips) {
            const tripidx = __.findIndex(acTrips, {uuid: tripLeg.uuid});
            if (tripidx >= 0) {
              const previousTripLeg = acTrips[tripidx - 1];
              const nextTripLeg = acTrips[tripidx + 1];
              if (previousTripLeg) {
                if (tripLeg.originAirportCode !== previousTripLeg.destinationAirportCode) {
                  addError(tripLeg.uuid,`Origin (${tripLeg.originAirportCode}) does not match previous flights (${previousTripLeg.airlineCode}${previousTripLeg.flightNo}) destination (${previousTripLeg.destinationAirportCode})`);
                }
              }
              if (nextTripLeg) {
                if (nextTripLeg.originAirportCode !== tripLeg.destinationAirportCode) {
                  addError(tripLeg.uuid,`Destination (${tripLeg.destinationAirportCode}) does not match next flights (${nextTripLeg.airlineCode}${nextTripLeg.flightNo}) origin (${nextTripLeg.originAirportCode})`);
                }
              }
            }
          }
        }
      });

      return errors;
    }

    Object.keys(__.omit(deltas, ['hasChanges'])).forEach(updateMode => {
      Object.keys(deltas[updateMode]).forEach(recordType => {
        deltas[updateMode][recordType].forEach(trip => {
          const tripUuid = trip.tripUuid;
          tripUuids.push(tripUuid);
        })
      })
    });
    tripUuids = __.uniq(tripUuids);
    tripUuids.forEach(tripUuid => {
      trips[tripUuid] = getTripLegs(tripUuid, deltas);
      const errors = validateTrip(trips[tripUuid], aircraftTrips);
      if (errors) {
        Object.entries(errors).forEach(([key, value]) => {
          if (__.has(deltaErrors, key)) {
            deltaErrors[key] = [...deltaErrors[key], ...value];
          } else {
            deltaErrors[key] = value;
          }
        })
      }
    });
  },[]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const emptyDelta = {
    hasChanges: false,
    added: {trips: [], scheduled: [], maintenance: []},
    deleted: {trips: [], scheduled: [], maintenance: []},
    updated: {trips: [], scheduled: [], maintenance: []}
  }

  const colours = props.colours;

  const extraKeys = props.scratchPadUser?[props.scratchPadUser]:[];
  const scratchPads = useSchedulingScratchPads({queryClient, extraKeys});
  const handleUpdateSchedulingScratchPad = useUpdateSchedulingScratchPad();

  const scrollRef = useRef();
  const blockSize = state.blockSize||50;
  const scrollState = useRef({
    lastScrollPosition: -100,
    scrollDirection: null
  })

  const getAirportTiming = async (airportCode, outbound, legType) => {
    const timings = await fetchAirportTimings({queryClient, extraKeys: [airportCode], useCache: true});
    let cargoProfileCode = "50";
    if (legType === "FERRY") {
      cargoProfileCode = "0";
    }
    const timing = __.find(timings, {cargoProfileCode, outbound});

    if (timing) return timing.durationMinutes;
    return 0;
  }

  const getScheduledTimetamps = (scheduledDate, offsetDay, departureTimeUTC, arrivalTimeUTC) => {
    const [departurehh, departuremm] = departureTimeUTC.split(':');
    const [arrivalhh, arrivalmm] = arrivalTimeUTC.split(':');
    const scheduledDepartureTimeUtc = moment.utc(scheduledDate).add(offsetDay, 'day').startOf('day').add(departurehh, 'hour').add(departuremm, 'minute');
    let scheduledArrivalTimeUtc = moment.utc(scheduledDate).add(offsetDay, 'day').startOf('day').add(arrivalhh, 'hour').add(arrivalmm, 'minute');
    if (scheduledArrivalTimeUtc.isBefore(scheduledDepartureTimeUtc)) {
      scheduledArrivalTimeUtc.add(1, 'day');
    }
    return {scheduledDepartureTimeUtc: scheduledDepartureTimeUtc.toISOString(), scheduledArrivalTimeUtc: scheduledArrivalTimeUtc.toISOString()}
  }

  const handleSaveSchedule = async (params) => {
    let deltas = {...scratchPads.data[props.scratchPad].deltas};
    const {record, postSuccess, postError} = params;
    try {
      const tripLegs = getTripLegs(record.tripUuid, deltas);
      if (!tripLegs) throw new Error("Unable to find legs associated with the trip");

      const {
        tripPrefix,
        tripNo,
        tripUuid,
        scheduledTripOverrideUuid,
        scheduledTripUuid,
        legs,
        scheduledDate,
        aircraftReg,
        oldAircraftReg
      } = record;

      for (let i = 0; i < tripLegs.length; i++) {
        const leg = tripLegs[i];
        const idx = __.findIndex(legs, {tripLegUuid: leg.uuid});
        if (idx < 0) {
          const deltaIdx = __.findIndex(deltas.updated.trips, {uuid: leg.uuid});
          if (deltaIdx < 0) {
            deltas.updated.trips.push({...leg, tripState: "DELETED", changed: true, deleted: true});
            deltas.hasChanges = true;
          } else {
            deltas.updated.trips[deltaIdx] = ({...leg, tripState: "DELETED", changed: true});
            deltas.hasChanges = true;
          }
        }
      }
      for (let i = 0; i < legs.length; i++) {
        const {
          tripLegUuid: uuid,
          originAirportCode,
          destinationAirportCode,
          alternateAirportCode,
          alternateAirportIcaoCode,
          transportType,
          airlineCode,
          flightNo,
          offsetDay,
          scheduledDepartureTimeUTC,
          scheduledArrivalTimeUTC,
          legType,
          allowLoading,
          allowThroughCargo,
          techStop,
        } = legs[i];
        const {scheduledDepartureTimeUtc, scheduledArrivalTimeUtc}  = getScheduledTimetamps(scheduledDate, offsetDay, scheduledDepartureTimeUTC, scheduledArrivalTimeUTC);

        let record = null;
        const idx = __.findIndex(tripLegs, {uuid});
        if (idx >= 0) {
          const tripLeg = tripLegs[idx];
          const aircraftChanged = tripLeg.aircraftChanged || aircraftReg !== oldAircraftReg;
          if (
            originAirportCode !== tripLeg.originAirportCode ||
            destinationAirportCode !== tripLeg.destinationAirportCode ||
            alternateAirportCode !== tripLeg.alternateAirportCode ||
            transportType !== tripLeg.transportType ||
            airlineCode !== tripLeg.airlineCode ||
            flightNo !== tripLeg.flightNo ||
            !moment.utc(scheduledDepartureTimeUtc).isSame(moment.utc(tripLeg.scheduledDepartureTimeUtc)) ||
            !moment.utc(scheduledArrivalTimeUtc).isSame(moment.utc(tripLeg.scheduledArrivalTimeUtc)) ||
            legType !== tripLeg.legType ||
            aircraftReg !== tripLeg.aircraftReg ||
            allowLoading !== tripLeg.allowLoading ||
            allowThroughCargo !== tripLeg.allowThroughCargo ||
            techStop !== tripLeg.techStop
          ) {
            record = {
              ...tripLegs[idx],
              originAirportCode,
              destinationAirportCode,
              alternateAirportCode,
              alternateAirportIcaoCode,
              transportType,
              airlineCode,
              flightNo,
              scheduledDepartureTimeUtc,
              scheduledArrivalTimeUtc,
              legType,
              aircraftReg,
              allowLoading,
              allowThroughCargo,
              changed: true,
              aircraftChanged,
              scheduledDate,
              techStop
            }
          }
        } else {
          const outboundTurnaround = await getAirportTiming(legs[i].originAirportCode, true, legs[i].legType);
          const inboundTurnaround = await getAirportTiming(legs[i].destinationAirportCode, false, legs[i].legType);
          const aircraftChanged = aircraftReg !== oldAircraftReg;

          record = {
            tripUuid: tripUuid,
            scheduledTripOverrideUuid,
            scheduledTripUuid,
            tripPrefix: tripPrefix || process.env.REACT_APP_TRIP_PREFIX || 'MAG',
            tripNo: tripNo,
            uuid: uuidv4(),
            originAirportCode,
            destinationAirportCode,
            alternateAirportCode,
            alternateAirportIcaoCode,
            transportType,
            airlineCode,
            flightNo,
            scheduledDepartureTimeUtc,
            scheduledArrivalTimeUtc,
            legType,
            aircraftReg,
            allowLoading,
            allowThroughCargo,
            changed: true,
            aircraftChanged,
            outboundTurnaround,
            inboundTurnaround,
            new: true,
            type: "SCHEDULED",
            scheduledDate,
            techStop
          }
        }
        if (record !== null) {
          const deltaIdx = __.findIndex(deltas.updated.trips, {uuid: record.uuid});
          if (deltaIdx < 0) {
            deltas.updated.trips.push(record);
          } else {
            deltas.updated.trips[deltaIdx] = record;
          }
          deltas.hasChanges = true;
        }
      }

      const oldData = scratchPads.data[props.scratchPad];
      const newData = {...scratchPads.data[props.scratchPad], deltas};
      validateDeltas(deltas);
      handleUpdateSchedulingScratchPad.mutate({extraKeys, record: newData, oldRecord: oldData});
      if (postSuccess) {
        postSuccess(record);
      }
    } catch (err) {
      console.error(err);
      if (postError) {
        postError({error: true, errorMessage: "Update Failed"});
      }
    }
  }

  const handleSaveTrip = {
    mutate: async (params) => {
      let deltas = {...scratchPads.data[props.scratchPad].deltas};
      const {record, postSuccess, postError} = params;
      const {
        tripPrefix,
        tripNo,
        tripUuid: tripsTripUuid,
        legs,
        tripDate,
        uniqueCostingNo,
      } = record;
      try {
        const tripLegs = getTripLegs(record.tripUuid, deltas);
        if (!tripLegs) throw new Error("Unable to find legs associated with the trip");

        for (let i = 0; i < tripLegs.length; i++) {
          const leg = tripLegs[i];
          const idx = __.findIndex(legs, {tripLegUuid: leg.uuid});
          if (idx < 0) {
            const deltaIdx = __.findIndex(deltas.updated.trips, {uuid: leg.uuid});
            if (deltaIdx < 0) {
              deltas.updated.trips.push({...leg, tripState: "DELETED", changed: true});
              deltas.hasChanges = true;
            } else {
              deltas.updated.trips[deltaIdx] = ({...leg, tripState: "DELETED", changed: true});
              deltas.hasChanges = true;
            }
          }
        }
        for (let i = 0; i < legs.length; i++) {
          const {
            tripUuid,
            tripLegUuid: uuid,
            originAirportCode,
            destinationAirportCode,
            alternateAirportCode,
            alternateAirportIcaoCode,
            transportType,
            airlineCode,
            flightNo,
            contractedDepartureTimeUTC: ctd,
            contractedArrivalTimeUTC: cta,
            scheduledDepartureTimeUTC: std,
            scheduledArrivalTimeUTC: sta,
            estimatedDepartureTimeUTC: etd,
            estimatedArrivalTimeUTC: eta,
            legType,
            aircraftId: aircraftReg,
            allowLoading,
            allowThroughCargo,
            techStop,
          } = legs[i];

          let record = null;
          const idx = __.findIndex(tripLegs, {uuid});
          if (idx >= 0) {
            const tripLeg = tripLegs[idx];
            const aircraftChanged = aircraftReg !== tripLeg.aircraftReg;
            if (
              originAirportCode !== tripLeg.originAirportCode ||
              destinationAirportCode !== tripLeg.destinationAirportCode ||
              alternateAirportCode !== tripLeg.alternateAirportCode ||
              transportType !== tripLeg.transportType ||
              airlineCode !== tripLeg.airlineCode ||
              flightNo !== tripLeg.flightNo ||
              ctd !== tripLeg.ctd ||
              cta !== tripLeg.cta ||
              std !== tripLeg.std ||
              sta !== tripLeg.sta ||
              etd !== tripLeg.etd ||
              eta !== tripLeg.eta ||
              legType !== tripLeg.legType ||
              aircraftReg !== tripLeg.aircraftReg ||
              allowLoading !== tripLeg.allowLoading ||
              allowThroughCargo !== tripLeg.allowThroughCargo||
              tripDate !== tripLeg.tripDate ||
              uniqueCostingNo !== tripLeg.uniqueCostingNo ||
              techStop !== tripLeg.techStop
            ) {
              record = {
                ...tripLegs[idx],
                tripDate,
                uniqueCostingNo,
                originAirportCode,
                destinationAirportCode,
                alternateAirportCode,
                alternateAirportIcaoCode,
                transportType,
                airlineCode,
                flightNo,
                scheduledDepartureTimeUtc: etd||std,
                scheduledArrivalTimeUtc: eta||sta,
                ctd,
                cta,
                std,
                sta,
                etd,
                eta,
                legType,
                aircraftReg,
                allowLoading,
                allowThroughCargo,
                changed: true,
                aircraftChanged,
                techStop
              }
            }
          } else {
            const outboundTurnaround = await getAirportTiming(legs[i].originAirportCode, true, legs[i].legType);
            const inboundTurnaround = await getAirportTiming(legs[i].destinationAirportCode, false, legs[i].legType);

            record = {
              tripUuid: tripUuid||tripsTripUuid,
              tripPrefix: tripPrefix || process.env.REACT_APP_TRIP_PREFIX || 'MAG',
              tripNo,
              tripDate,
              uniqueCostingNo,
              uuid,
              originAirportCode,
              destinationAirportCode,
              alternateAirportCode,
              alternateAirportIcaoCode,
              transportType,
              airlineCode,
              flightNo,
              scheduledDepartureTimeUtc: etd||std,
              scheduledArrivalTimeUtc: eta||sta,
              ctd,
              cta,
              std,
              sta,
              etd,
              eta,
              legType,
              aircraftReg,
              allowLoading,
              allowThroughCargo,
              changed: true,
              aircraftChanged: false,
              outboundTurnaround,
              inboundTurnaround,
              tripState: "SCHEDULED",
              new: true,
              type: "TRIP",
              techStop
            }
          }
          if (record !== null) {
            const deltaIdx = __.findIndex(deltas.updated.trips, {uuid: record.uuid});
            if (deltaIdx < 0) {
              deltas.updated.trips.push(record);
            } else {
              deltas.updated.trips[deltaIdx] = record;
            }
            deltas.hasChanges = true;
          }
        }

        const oldData = scratchPads.data[props.scratchPad];
        const newData = {...scratchPads.data[props.scratchPad], deltas};
        validateDeltas(deltas);
        handleUpdateSchedulingScratchPad.mutate({extraKeys, record: newData, oldRecord: oldData});
        if (postSuccess) {
          postSuccess(record);
        }
      } catch (err) {
        console.error(err);
        if (postError) {
          postError({error: true, errorMessage: "Update Failed"});
        }
      }
    }
  }

  const {
    AddTripDialog, openAddTrip,
    //EditTripDialog, openEditTrip,
  } = dialogs(SystemData, apiSitePrefix, [], handleSaveTrip, handleSaveTrip, null, null, classes);

  const {
    Dialog: EditScheduledTripPlanningDialog,
    open: openEditSchedulePlanning,
  } = editScheduledTripPlanningDialog(SystemData, apiSitePrefix, [], handleSaveSchedule, classes);


  useEffect(()=> {
    const handleZoomIn = ()=> {
      if (blockSizes.indexOf(state.blockSize) > 0 && scrollRef.current) {
        const oldBlockSize = state.blockSize;
        const offset = state.clientWidth / 2;
        const blockSize = blockSizes[blockSizes.indexOf(state.blockSize) - 1];
        const blockInMiddle = (scrollRef.current.scrollLeft + (offset - offsets[oldBlockSize])) / oldBlockSize;
        const datetime = moment.utc(state.startDate).add(blockInMiddle, 'hour').toISOString();
        const scrollLeft = (blockSize/60) * (moment.utc(datetime).diff(moment.utc(state.startDate),'minute')) - (offset - offsets[blockSize]);
        if (blockSizes.indexOf(blockSize) >= 0) {
          //console.log('handleZoomIn');
          setSetting({blockSize});
          setState({...state, blockSize, scrollLeft});
          scrollRef.current.scrollLeft = scrollLeft;
          setTimeout(() => {
            scrollRef.current.scrollLeft = scrollLeft;
          }, 1);
        }
      }
    }

    const handleZoomOut = ()=> {
      if (blockSizes.indexOf(state.blockSize) < blockSizes.length - 1 && scrollRef.current) {
        const oldBlockSize = state.blockSize;
        const offset = state.clientWidth / 2;
        const blockSize = blockSizes[blockSizes.indexOf(state.blockSize) + 1];
        const blockInMiddle = (scrollRef.current.scrollLeft + (offset - offsets[oldBlockSize])) / oldBlockSize;
        const datetime = moment.utc(state.startDate).add(blockInMiddle, 'hour').toISOString();
        const scrollLeft = (blockSize/60) * (moment.utc(datetime).diff(moment.utc(state.startDate),'minute')) - (offset - offsets[blockSize]);
        if (blockSizes.indexOf(blockSize)) {
          //console.log('handleZoomOut');
          setSetting({blockSize});
          setState({...state, blockSize, scrollLeft});
          scrollRef.current.scrollLeft = scrollLeft;
          setTimeout(() => {
            scrollRef.current.scrollLeft = scrollLeft;
          }, 1);
        }
      }
    }

    const handleZoomTo = (blockSize)=> {
      const oldBlockSize = state.blockSize;
      if (blockSizes.indexOf(blockSize)) {
        //console.log('handleZoomTo');
        setSetting({blockSize});
        setState({...state, blockSize: blockSize});
      }
      const factor = blockSize / oldBlockSize;
      const offset = state.clientWidth / 2;
      const offsetBlocksOld = offset / oldBlockSize;
      const offsetBlocksNew = offset / blockSize;
      const offsetDiff = (offsetBlocksOld - offsetBlocksNew) * blockSize;
      if (scrollRef.current) {
        scrollRef.current.scrollLeft = (scrollRef.current.scrollLeft * factor) + offsetDiff;
      }
    }

    const handleScrollTo = async (datetime)=> {
      const startPreviousMonth = moment(datetime).startOf('month').subtract(1,'month').format('YYYY-MM-DD HH:mm:ss');
      const startMonth = moment(datetime).startOf('month').format('YYYY-MM-DD HH:mm:ss');
      const startMonth2 = moment(datetime).startOf('month').add(1,'month').format('YYYY-MM-DD HH:mm:ss');
      const endNextMonth = moment(datetime).endOf('month').add(1,'month').format('YYYY-MM-DD HH:mm:ss');

      const {aircraftTrips, aircraftMx} = await getThreeMonthsData(startPreviousMonth, startMonth, startMonth2);

      if (!scrollRef.current) return;
      scrollRef.current.scrollLeft = state.scrollLeft;
      //TODO: Need to adjust for middle of window
      const offset = state.clientWidth / 2;
      const scrollLeft = (state.blockSize/60) * (moment.utc(datetime).diff(moment.utc(startPreviousMonth),'minute')) - (offset - offsets[state.blockSize]);
      //console.log('handleScrollTo');
      flags.current.dataLoaded++;
      setState({...state, dataLoaded: ++state.dataLoaded, scrollLeft, aircraftTrips, aircraftMx, startDate:startPreviousMonth, startTime:startPreviousMonth, endTime:endNextMonth});
      scrollRef.current.scrollLeft = scrollLeft;
    }

    const handleScrollOffset = (offset)=> {
      if (scrollRef.current) {
        const scrollPos = scrollRef.current.scrollLeft + offset;
        if (scrollPos > 0) {
          scrollRef.current.scrollLeft = scrollPos;
        } else {
          scrollRef.current.scrollLeft = 0;
        }
      }
    }

    const handleScrollForward = ()=> {
      if (scrollRef.current) {
        const offset = Math.floor(state.clientWidth / 2);
        const scrollPos = scrollRef.current.scrollLeft + offset;
        if (scrollPos > 0) {
          scrollRef.current.scrollLeft = scrollPos;
        } else {
          scrollRef.current.scrollLeft = 0;
        }
      }
    }

    const handleScrollBackward = ()=> {
      if (scrollRef.current) {
        const offset = Math.floor(state.clientWidth / 2);
        const scrollPos = scrollRef.current.scrollLeft - offset;
        if (scrollPos > 0) {
          scrollRef.current.scrollLeft = scrollPos;
        } else {
          scrollRef.current.scrollLeft = 0;
        }
      }
    }

    const getThreeMonthsDataRaw = async (startMonth, startMonth2, startMonth3, force, refreshing) => {
      //console.log(`${new Date()} - Getting Data: ${startMonth} ${startMonth2} ${startMonth3} ${force}`);
      if (force) {
        emptyCache();
      }
      const p1 = getMonthsTripData(startMonth, force, refreshing);
      const p2 = getMonthsTripData(startMonth2, force, refreshing);
      const p3 = getMonthsTripData(startMonth3, force, refreshing);
      const p4 = getMonthsMxData(startMonth, force);
      const p5 = getMonthsMxData(startMonth2, force);
      const p6 = getMonthsMxData(startMonth3, force);

      if (scrollState.current && scrollState.current.scrollDirection) {
        const preloadDate = scrollState.current.scrollDirection === "left"?moment(startMonth).subtract(1, 'month'):moment(startMonth3).add(1, 'month');
        getMonthsTripData(preloadDate.format('YYYY-MM-DD HH:mm:ss'));
        getMonthsMxData(preloadDate.format('YYYY-MM-DD HH:mm:ss'));
      }

      const [m1,m2,m3, mx1, mx2, mx3] = await Promise.all([p1,p2,p3,p4,p5,p6]);
      //console.log(`${new Date()} - Processing Data: ${startMonth} ${startMonth2} ${startMonth3}`);
      const aircraft1 = Object.keys(m1.data.flights);
      const aircraft2 = Object.keys(m2.data.flights);
      const aircraft3 = Object.keys(m3.data.flights);
      const aircraft4 = mx1.data.map(rec=>`${rec.aircraftReg.substring(0,2)}-${rec.aircraftReg.substring(2)}`);
      const aircraft5 = mx2.data.map(rec=>`${rec.aircraftReg.substring(0,2)}-${rec.aircraftReg.substring(2)}`);
      const aircraft6 = mx3.data.map(rec=>`${rec.aircraftReg.substring(0,2)}-${rec.aircraftReg.substring(2)}`);
      const aircraft7 = props.editing && scratchPads && Array.isArray(scratchPads.data) && scratchPads.data[props.scratchPad] && scratchPads.data[props.scratchPad].deltas && scratchPads.data[props.scratchPad].deltas.updated && scratchPads.data[props.scratchPad].deltas.updated.trips?__.uniq(scratchPads.data[props.scratchPad].deltas.updated.trips.map(trip => trip.aircraftReg)):[];
      const aircraft = __.uniq([...aircraft1, ...aircraft2, ...aircraft3, ...aircraft4, ...aircraft5, ...aircraft6, ...aircraft7]).sort();
      const aircraftTrips = {};
      const aircraftMx = {};
      aircraft.forEach(callSign => {
        let trips = [];
        let mx = [];
        if (aircraft1.indexOf(callSign) >= 0) trips = [...trips, ...m1.data.flights[callSign]];
        if (aircraft2.indexOf(callSign) >= 0) trips = [...trips, ...m2.data.flights[callSign]];
        if (aircraft3.indexOf(callSign) >= 0) trips = [...trips, ...m3.data.flights[callSign]];
        if (aircraft4.indexOf(callSign) >= 0) mx = [...mx, ...__.filter(mx1.data, {aircraftReg: callSign.split('-').join('')})];
        if (aircraft5.indexOf(callSign) >= 0) mx = [...mx, ...__.filter(mx2.data, {aircraftReg: callSign.split('-').join('')})];
        if (aircraft6.indexOf(callSign) >= 0) mx = [...mx, ...__.filter(mx3.data, {aircraftReg: callSign.split('-').join('')})];
        aircraftTrips[callSign] = __.uniqBy(trips, (rec) => `${rec.tripNo}${rec.scheduledDepartureTimeUtc}`);
        aircraftMx[callSign] = __.uniqBy(mx, 'iopsScheduledMxUuid');
      })
      //console.log(`${new Date()} - Processed Data: ${startMonth} ${startMonth2} ${startMonth3}`);
      return {aircraftTrips, aircraftMx}
    }

    const getThreeMonthsData = __.throttle(getThreeMonthsDataRaw, 10, { 'trailing': false });

    const changeState = __.throttle((scrollLeft, aircraftTrips, aircraftMx, startMonth, endNextMonth) => {
      setState({...state, scrollLeft, aircraftTrips, aircraftMx, startDate:startMonth, startTime:startMonth, endTime:endNextMonth});
      if (scrollRef && scrollRef.current) scrollRef.current.scrollLeft = scrollLeft;
    }, 10, {leading: false, trailing: true})

    const handleTimeWindowLoaded = __.throttle(async () => {
      console.log('handling window loaded:', flags.current, state.initialized);
      if (flags.current.dataLoaded === 0 && state.initialized) {
        const startMonth = moment(state.startDate).startOf('month').format('YYYY-MM-DD HH:mm:ss');
        const startMonth2 = moment(state.startDate).startOf('month').add(1,'month').format('YYYY-MM-DD HH:mm:ss');
        const startMonth3 = moment(state.startDate).startOf('month').add(2,'month').format('YYYY-MM-DD HH:mm:ss');
        const endNextMonth = moment(state.startDate).endOf('month').add(2,'month').format('YYYY-MM-DD HH:mm:ss');

        const {aircraftTrips, aircraftMx} = await getThreeMonthsData(startMonth, startMonth2, startMonth3, false);

        if (scrollRef.current) {
          scrollRef.current.scrollLeft = state.scrollLeft;
          const scrollLeft = state.scrollLeft;//(state.blockSize/60) * (moment.utc().diff(moment.utc(startMonth),'minute'));
          flags.current.dataLoaded++;
          changeState(scrollLeft, aircraftTrips, aircraftMx, startMonth, endNextMonth);
          // if (scrollLeft !== scrollRef.current.scrollLeft) {
          //   changeState(scrollLeft, aircraftTrips, aircraftMx, startMonth, endNextMonth);
          //   // setState({...state, scrollLeft, aircraftTrips, aircraftMx, startDate:startMonth, startTime:startMonth, endTime:endNextMonth});
          //   // scrollRef.current.scrollLeft = scrollLeft;
          // }
        }
      }
    }, 10, {leading: false, trailing: true})

    const delay = (milliseconds) => new Promise(resolve => {
      setTimeout(resolve, milliseconds);
    });

    const handleTripLegPointer = async (params) => {
      const element = document.getElementById(params.tripLegKey);
      if (element) {
        element.click();
      }
      await delay(100);
      setState({...state, selectedTripLegKey: params.tripLegKey});
    }


    const handleTimeWindowAtStart = async () => {
      if (!scrollRef.current) return;
      const startMonth = moment(state.startDate).startOf('month').subtract(1,'month').format('YYYY-MM-DD HH:mm:ss');
      const startMonth2 = moment(state.startDate).startOf('month').format('YYYY-MM-DD HH:mm:ss');
      const startMonth3 = moment(state.startDate).startOf('month').add(1,'month').format('YYYY-MM-DD HH:mm:ss');
      const endNextMonth = moment(state.startDate).endOf('month').add(1,'month').format('YYYY-MM-DD HH:mm:ss');

      const {aircraftTrips, aircraftMx} = await getThreeMonthsData(startMonth, startMonth2, startMonth3);

      const scrollLeft = (state.blockSize/60) * (moment.utc(startMonth2).diff(moment.utc(startMonth),'minute'));
      //console.log('handleTimeWindowAtStart');
      flags.current.dataLoaded++;
      setState({...state, dataLoaded: ++state.dataLoaded, scrollLeft, aircraftTrips, aircraftMx, startDate:startMonth, startTime:startMonth, endTime:endNextMonth});
      scrollRef.current.scrollLeft = scrollLeft;
    }

    const handleTimeWindowAtEnd = async () => {
      if (!scrollRef.current) return;
      const startMonth = moment(state.startDate).startOf('month').add(1, 'month').format('YYYY-MM-DD HH:mm:ss');
      const startMonth2 = moment(state.startDate).startOf('month').add(2,'month').format('YYYY-MM-DD HH:mm:ss');
      const startMonth3 = moment(state.startDate).startOf('month').add(3,'month').format('YYYY-MM-DD HH:mm:ss');
      const endNextMonth = moment(state.startDate).endOf('month').add(3,'month').format('YYYY-MM-DD HH:mm:ss');

      const {aircraftTrips, aircraftMx} = await getThreeMonthsData(startMonth, startMonth2, startMonth3);

      const offset = state.clientWidth;
      const scrollLeft = (state.blockSize/60) * (moment.utc(startMonth3).diff(moment.utc(startMonth),'minute')) - offset;
      //console.log('handleTimeWindowAtEnd');
      flags.current.dataLoaded++;
      setState({...state, dataLoaded: ++state.dataLoaded, scrollLeft, aircraftTrips, aircraftMx, startDate:startMonth, startTime:startMonth, endTime:endNextMonth});
      scrollRef.current.scrollLeft = scrollLeft;
    }

    const getNextTrips = (deltas, uuid, scheduledDepartureTimeUtc, aircraftReg) => {
      let nextTrips = [];
      Object.keys(monthsTripData).forEach(monthKey => {
        if (Array.isArray(Object.keys(monthsTripData[monthKey]?.data?.data?.flights)) && Array.isArray(monthsTripData[monthKey].data.data.flights[aircraftReg])){
          monthsTripData[monthKey].data.data.flights[aircraftReg].forEach(trip => {
            if (trip.scheduledArrivalTimeUtc >= scheduledDepartureTimeUtc) {
              nextTrips.push(trip);
            }
          })
        }
      });
      Object.keys(__.omit(deltas, ['hasChanges'])).forEach(updateMode => {
        Object.keys(deltas[updateMode]).forEach(recordType => {
          deltas[updateMode][recordType].forEach(trip => {
            const idx = __.findIndex(nextTrips, {uuid: trip.uuid});
            if (idx >= 0) {
              if (trip.scheduledArrivalTimeUtc >= scheduledDepartureTimeUtc && trip.aircraftReg === aircraftReg && trip.tripState !== 'DELETED' && trip.tripState !== 'CANCELLED') {
                nextTrips[idx]=trip;
              } else {
                nextTrips.splice(idx, 1);
              }
            } else {
              if (trip.scheduledArrivalTimeUtc >= scheduledDepartureTimeUtc && trip.aircraftReg === aircraftReg) {
                if (trip.tripState !== 'DELETED' && trip.tripState !== 'CANCELLED') nextTrips.push(trip);
              }
            }
          })
        })
      });
      nextTrips = __.sortBy(nextTrips, tripLeg => moment.utc(tripLeg.scheduledDepartureTimeUtc).toISOString());
      return nextTrips;
    }

    const shuffleTrips = (_trip, deltas) => {
      let trip = _trip;

      let nextTrips = getNextTrips(deltas, trip.uuid, trip.scheduledDepartureTimeUtc, trip.aircraftReg);

      const tripidx = __.findIndex(nextTrips, {uuid: trip.uuid});
      if (tripidx < 0) {
        return true;
      }

      let aborted = false;
      for (let i = (tripidx + 1); i < nextTrips.length; i++) {
        const {scheduledArrivalTimeUtc, inboundTurnaround, outboundTurnaround} = trip;
        const endTime = moment.utc(scheduledArrivalTimeUtc).add(inboundTurnaround, 'minute');

        const nextTrip = __.cloneDeep(nextTrips[i]);

        const nextStartTime = moment.utc(nextTrip.scheduledDepartureTimeUtc).subtract(nextTrip.outboundTurnaround, 'minute');
        const minutesRequired = endTime.diff(nextStartTime, 'minute');
        if (nextStartTime.isBefore(endTime)) {
          if (nextTrip.tripState === 'TRIP' && (nextTrip.tripState !== 'ESTIMATED' || nextTrip.type === 'SCHEDULED')) {
            aborted = true;
            break;
          }
          const newScheduledDepartureTimeUtc = moment.utc(nextTrip.scheduledDepartureTimeUtc).add(minutesRequired, 'minute').toISOString();
          const newScheduledArrivalTimeUtc = moment.utc(nextTrip.scheduledArrivalTimeUtc).add(minutesRequired, 'minute').toISOString();
          nextTrip.scheduledDepartureTimeUtc = newScheduledDepartureTimeUtc;
          nextTrip.scheduledArrivalTimeUtc = newScheduledArrivalTimeUtc;
          nextTrip.aircraftChanged = nextTrip.aircraftChanged | false;
          if (props.estimatedMode && nextTrip.type === "TRIP") nextTrip.tripState='ESTIMATED';
          nextTrip.changed = true;
          if (nextTrip.tripState === "SCHEDULED") {
            nextTrip.std = nextTrip.scheduledDepartureTimeUtc;
            nextTrip.sta = nextTrip.scheduledArrivalTimeUtc;
          }
          nextTrip.etd = nextTrip.scheduledDepartureTimeUtc;
          nextTrip.eta = nextTrip.scheduledArrivalTimeUtc;
    
          const idx = __.findIndex(deltas.updated.trips, {uuid: nextTrip.uuid});
          if (idx < 0) {
            deltas.updated.trips.push(nextTrip);
          } else {
            deltas.updated.trips[idx]=nextTrip;
          }
          trip = nextTrip;

          if ((i - tripidx) === 20) {
            aborted = true;
            break;
          }
        } else {
          break;
        }
      }

      return aborted;
    }

    const handleTimeWindowDroppedMx = async (mxDelta) => {
      let deltas = {...scratchPads.data[props.scratchPad].deltas};
      const idx = __.findIndex(deltas.updated.maintenance, {iopsScheduledMxUuid: mxDelta.iopsScheduledMxUuid});
      if (idx < 0) {
        deltas.updated.maintenance.push(mxDelta);
        deltas.hasChanges = true;
      } else {
        deltas.updated.maintenance[idx]=mxDelta;
        deltas.hasChanges = true;
      }
      const oldData = scratchPads.data[props.scratchPad];
      const newData = {...scratchPads.data[props.scratchPad], deltas};
      validateDeltas(deltas);
      handleUpdateSchedulingScratchPad.mutate({extraKeys, record: newData, oldRecord: oldData});
    }

    const handleTimeWindowDroppedTrip = async (tripDelta) => {
      if (tripDelta.type === "TRIP" && props.estimatedMode && tripDelta.tripState === 'SCHEDULED') {
        tripDelta.tripState = 'ESTIMATED';
      }
      if (tripDelta.tripState === "SCHEDULED") {
        tripDelta.std = tripDelta.scheduledDepartureTimeUtc;
        tripDelta.sta = tripDelta.scheduledArrivalTimeUtc;
      }
      tripDelta.etd = tripDelta.scheduledDepartureTimeUtc;
      tripDelta.eta = tripDelta.scheduledArrivalTimeUtc;

      let deltas = {...scratchPads.data[props.scratchPad].deltas};
      let aborted = false;
      if (props.nudgeMode && tripDelta.aircraftChanged === false) {
        const updatedDeltas = __.cloneDeep(scratchPads.data[props.scratchPad].deltas);
        aborted = shuffleTrips(tripDelta, updatedDeltas, 0);
        if (!aborted) {
          deltas = updatedDeltas;
        }
      }
      const idx = __.findIndex(deltas.updated.trips, {uuid: tripDelta.uuid});
      if (idx < 0) {
        deltas.updated.trips.push(tripDelta);
        deltas.hasChanges = true;
      } else {
        deltas.updated.trips[idx]=tripDelta;
        deltas.hasChanges = true;
      }
      const oldData = scratchPads.data[props.scratchPad];
      const newData = {...scratchPads.data[props.scratchPad], deltas};
      validateDeltas(deltas);
      handleUpdateSchedulingScratchPad.mutate({extraKeys, record: newData, oldRecord: oldData});
    }

    const checkIfDeltaHasChanges = (deltas) => {
      let hasChanges = false;
      Object.keys(__.omit(deltas, ['hasChanges'])).forEach(updateMode => {
        Object.keys(deltas[updateMode]).forEach(recordType => {
          if (deltas[updateMode][recordType].length > 0) {
            hasChanges = true;
          }
        });
      });
      deltas.hasChanges = hasChanges;
      return hasChanges;
    }

    const handleTripActionEditScheduledTrip = async (data) => {
      const {tripData} = data;
      let deltas = {...scratchPads.data[props.scratchPad].deltas};
      const tripLegs = getTripLegs(tripData.tripUuid, deltas);
      if (!tripLegs) return;
      let tripUuid = null;
      let tripPrefix = process.env.REACT_APP_TRIP_PREFIX || "MAG";
      let tripNo = null;
      const legs = tripLegs.map(leg=> {
        if (leg.tripUuid) tripUuid = leg.tripUuid;
        if (leg.tripNo) {
          if (`${leg.tripNo}`.startsWith((process.env.REACT_APP_TRIP_PREFIX || 'MAG'))) {
            tripNo = leg.tripNo.substring(3);
          } else {
            tripNo = `${leg.tripNo}`;
          }
        }
        return {
          type: leg.type,
          tripUuid: leg.tripUuid,
          tripLegUuid: leg.uuid,
          originAirportCode: leg.originAirportCode,
          destinationAirportCode: leg.destinationAirportCode,
          alternateAirportCode: leg.alternateAirportCode||'',
          alternateAirportIcaoCode: leg.alternateAirportIcaoCode||'',
          transportType: leg.transportType,
          airlineCode: leg.airlineCode,
          flightNo: leg.flightNo,
          offsetDay: moment.utc(leg.scheduledDepartureTimeUtc).startOf('day').diff(moment.utc(leg.scheduledDate), 'day'),
          scheduledDepartureTimeUTC: moment.utc(leg.scheduledDepartureTimeUtc).format('HH:mm'),
          scheduledArrivalTimeUTC: moment.utc(leg.scheduledArrivalTimeUtc).format('HH:mm'),
          legType: leg.legType,
          aircraftReg: leg.aircraftReg,
          allowLoading: leg.allowLoading,
          allowThroughCargo: leg.allowThroughCargo,
          scheduledDate: leg.scheduledDate,
          techStop: leg.techStop,
        }
      })
      const trip = {
        tripUuid,
        scheduledTripOverrideUuid: tripLegs[0].scheduledTripOverrideUuid,
        scheduledTripUuid: tripLegs[0].scheduledTripUuid,
        tripPrefix,
        tripNo,
        legs,
        scheduledDate: tripLegs[0].scheduledDate,
        aircraftReg: tripLegs[0].aircraftReg,
        oldAircraftReg: tripLegs[0].aircraftReg
      }
      openEditSchedulePlanning(trip);
    }

    const handleTripActionDownloadTripSheet = async (data) => {
      handleTripActionTripSheet(data, true, true);
    }

    const handleTripActionEmailTripSheet = async (data) => {
      handleTripActionTripSheet(data, false, true);
    }

    const handleTripActionDownloadSectorSheet = async (data) => {
      handleTripActionTripSheet(data, true, false);
    }

    const handleTripActionEmailSectorSheet = async (data) => {
      handleTripActionTripSheet(data, false, false);
    }

    const handleTripActionTripSheet = async (data, download, trip) => {
      const {tripData} = data;
      const tripUuid = tripData.tripUuid;
      const tripLegUuid = !trip ? tripData.uuid : "null";

      SystemData.toggleLoadingProgress(true);
      try {
        const response = await axios.get(`${apiSitePrefix}/trip/tripsheet/${tripUuid}/${tripLegUuid}`, {
          headers: {
            'Access-Control-Allow-Origin': '*',
          }
        });
        SystemData.toggleLoadingProgress(false);
        if (response && response.data) {
          if (response.data.status && response.data.excelSignedUrl) {
            if (!download) {
              const fileName = response.data.downloadFileName;
              const flightDate = moment(tripData.std).format("DD MMM YYYY");
              const subjectPrefix = `${tripData.tripNo} // ${!trip ? "Magma Aviation Flight Sheet" : "Magma Aviation Trip Sheet"}`;
              const subject = `${subjectPrefix} // ${tripData.airlineCode}${tripData.flightNo} // ${tripData.originAirportCode} - ${tripData.destinationAirportCode} // ${flightDate} // ${tripData.aircraftReg}`;
              const attachmentDescription = `${!trip ? "Flight" : "Trip"} Sheet for ${tripData.airlineCode}${tripData.flightNo} / ${tripData.originAirportCode} - ${tripData.destinationAirportCode} / ${flightDate} / ${tripData.aircraftReg}`;
              const emailRecord = {
                recipients: "",
                carbonCopy: defaultValues && __.has(defaultValues, "ccList") ? defaultValues.ccList : "",
                subject: subject,
                templateType: "TRIP_SHEET",
                templateUuid: "dummyTemplateUuid",
                attachmentDescription: attachmentDescription,
                attachmentUrl: response.data.excelSignedUrl,
                fileName: fileName.replaceAll("/",""),
                attachments: "Trip Sheet, DLS, NOTOC",
                repeatData: [],
                contactRole: "TRIP SHEET",
                tripLegUuid: tripData.uuid,
                additionalAttachments: response.data.additionalAttachments
              }
              SystemData.sendEmail(emailRecord, `Send ${trip ? "Trip" : "Sector"} Sheet for ${trip ? tripData.tripNo : tripData.flightNo}`, true);
            } else {
              window.open(response.data.excelSignedUrl, '_blank', 'noopener,noreferrer');
            }
          } else {
            SystemData.openAlert(
              "Error",
              `${response.data.error ? "Failed to produce report due to the following error: " + response.data.error : "Failed to produce " + (trip ? "Trip" : "Sector" + "Sheet")}`
            );
          }
        }
      } catch (err) {
        SystemData.toggleLoadingProgress(false);
        SystemData.openAlert(
          "Error",
          `An unexpected error occurred`
        );
      }
    }

    const editScratchPadTrip = (tripData) => {

      let deltas = {...scratchPads.data[props.scratchPad].deltas};
      const tripLegs = getTripLegs(tripData.tripUuid, deltas);
      if (!tripLegs) return;
      let tripUuid = null;
      let tripPrefix = process.env.REACT_APP_TRIP_PREFIX || "MAG";
      let tripNo = null;
      let tripDate = null;
      let uniqueCostingNo = null;
      const tripRoute = [];
      tripRoute.push(tripLegs[0].originAirportCode);
      const legs = tripLegs.map(leg=> {
        if (leg.tripUuid) tripUuid = leg.tripUuid;
        if (leg.tripNo) {
          if (`${leg.tripNo}`.startsWith((process.env.REACT_APP_TRIP_PREFIX || 'MAG'))) {
            tripNo = leg.tripNo.substring(3);
          } else {
            tripNo = `${leg.tripNo}`;
          }
        }
        if (leg.tripDate) tripDate = leg.tripDate;
        if (leg.uniqueCostingNo) uniqueCostingNo = leg.uniqueCostingNo;
        tripRoute.push(leg.destinationAirportCode)
        return {
          tripUuid: leg.tripUuid,
          tripLegUuid: leg.uuid,
          originAirportCode: leg.originAirportCode,
          destinationAirportCode: leg.destinationAirportCode,
          alternateAirportCode: leg.alternateAirportCode||'',
          alternateAirportIcaoCode: leg.alternateAirportIcaoCode||'',
          transportType: leg.transportType,
          airlineCode: leg.airlineCode,
          flightNo: leg.flightNo,
          contractedDepartureTimeUTC: leg.ctd,
          contractedArrivalTimeUTC: leg.cta,
          scheduledDepartureTimeUTC: leg.std,
          scheduledArrivalTimeUTC: leg.sta,
          estimatedDepartureTimeUTC: leg.etd,
          estimatedArrivalTimeUTC: leg.eta,
          legType: leg.legType,
          aircraftId: leg.aircraftReg,
          allowLoading: leg.allowLoading,
          allowThroughCargo: leg.allowThroughCargo,
          techStop: leg.techStop,
        }
      })
      const trip = {
        tripUuid,
        tripPrefix,
        tripNo,
        legs,
        tripDate: moment(tripDate||tripLegs[0].ctd||tripLegs[0].std).format('YYYY-MM-DD'),
        uniqueCostingNo,
        tripRoute: tripRoute.join('-')
      }
      //console.log('Edit Trip', trip);
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("EditTripDialog.open", trip);

//      openEditTrip(trip);

    }

    const handleTripActionEditTrip = async (data) => {
      const {tripData} = data;
      const tripUuid = tripData.tripUuid;

      if (tripData.changed) {
        editScratchPadTrip(tripData)
      } else {
        try {
          const response = await axios.get(`${apiSitePrefix}/trip/get/${tripUuid}`, {
            headers: {
              'Access-Control-Allow-Origin': '*',
            }
          });
          if (response && response.data) {
            //openEditTrip(response.data);
            eventBus.trigger('RouteView.pause', true);
            eventBus.trigger("EditTripDialog.open", response.data);
          } else {
            SystemData.openAlert(
              "Error",
              `Failed to retrieve data for Trip`
            );
          }
        } catch (err) {
          SystemData.openAlert(
            "Error",
            `Failed to retrieve data for Trip`
          );
        }
      }
    }

    const handleTripActionAddTrip = async () => {
      const newTripRecordTemplate = {
        recordType: "TRIP",
        aircraft: [],
        legs:[],
        cancelled: false,
        tripNo: null
      }
      let dateTime = moment().toISOString();
      if (scrollRef.current) {
        const oldBlockSize = state.blockSize;
        const offset = state.clientWidth / 2;
        const blockInMiddle = (scrollRef.current.scrollLeft + (offset - offsets[oldBlockSize])) / oldBlockSize;
        const scrollTime = moment.utc(state.startDate).add(blockInMiddle, 'hour');
        const newMinutes = scrollTime.get('minutes');
        const fiveMinDiff = newMinutes % 5;
        dateTime = scrollTime.subtract(fiveMinDiff, 'minute').toISOString();
      }

      const trip = {
        ...__.cloneDeep(newTripRecordTemplate),
        tripDate: dateTime,
        tripUuid: uuidv4()
      }
      eventBus.trigger('RouteView.pause', true);
      openAddTrip(trip);
    }

    const handleTripActionUndo = async (data) => {
      const deltas = {...scratchPads.data[props.scratchPad].deltas};
      const idx = __.findIndex(deltas.updated.trips, {uuid: data.tripData.uuid});
      if (idx >= 0) {
        deltas.updated.trips.splice(idx, 1);
      }
      checkIfDeltaHasChanges(deltas);
      const oldData = scratchPads.data[props.scratchPad];
      const newData = {...scratchPads.data[props.scratchPad], deltas};
      handleUpdateSchedulingScratchPad.mutate({extraKeys, record: newData, oldRecord: oldData});
    }

    const handleTripActionUndoTrip = async (data) => {
      const {tripData} = data;
      const {tripUuid} = tripData;
      const deltas = {...scratchPads.data[props.scratchPad].deltas};

      let idx = __.findIndex(deltas.updated.trips, {tripUuid});
      while (idx >= 0) {
        deltas.updated.trips.splice(idx, 1);
        idx = __.findIndex(deltas.updated.trips, {tripUuid});
      }
      checkIfDeltaHasChanges(deltas);
      const oldData = scratchPads.data[props.scratchPad];
      const newData = {...scratchPads.data[props.scratchPad], deltas};
      handleUpdateSchedulingScratchPad.mutate({extraKeys, record: newData, oldRecord: oldData});
    }

    const moveTripToAircraft = async (tripData, deltas, aircraftReg) => {
      const tripLegs = getTripLegs(tripData.tripUuid, deltas);

      tripLegs.forEach(trip => {
        const idx = __.findIndex(deltas.updated.trips, {uuid: trip.uuid});
        if (idx < 0) {
          deltas.updated.trips.push({...trip, aircraftReg, aircraftChanged: true, changed: true});
          deltas.hasChanges = true;
        } else {
          deltas.updated.trips[idx]=({...trip, aircraftReg, aircraftChanged: true, changed: true});
          deltas.hasChanges = true;
        }
      });
      const oldData = scratchPads.data[props.scratchPad];
      const newData = {...scratchPads.data[props.scratchPad], deltas};
      handleUpdateSchedulingScratchPad.mutate({extraKeys, record: newData, oldRecord: oldData});
    }

    const handleChangeTripsAircraft = async (data) => {
      const {tripData, extraData} = data;
      if (!extraData) return;
      const {aircraftTailNumber: aircraftReg} = extraData;
      const deltas = {...scratchPads.data[props.scratchPad].deltas};
      await moveTripToAircraft(tripData, deltas, aircraftReg);
    }

    const handleTripActionCancelTrip = async (data) => {
      const {tripData} = data;
      const deltas = {...scratchPads.data[props.scratchPad].deltas};
      Object.keys(monthsTripData).forEach(monthKey => {
        if (Array.isArray(Object.keys(monthsTripData[monthKey]?.data?.data?.flights))){
          Object.keys(monthsTripData[monthKey].data.data.flights).forEach(aircraftKey => {
            monthsTripData[monthKey].data.data.flights[aircraftKey].forEach(trip => {
              if (trip.tripUuid === tripData.tripUuid) {
                const idx = __.findIndex(deltas.updated.trips, {uuid: trip.uuid});
                if (idx < 0) {
                  deltas.updated.trips.push({...trip, tripState: "CANCELLED", changed: true});
                  deltas.hasChanges = true;
                } else {
                  deltas.updated.trips[idx]=({...trip, tripState: "CANCELLED", changed: true});
                  deltas.hasChanges = true;
                }
              }
            })
          })
        }
      });
      const oldData = scratchPads.data[props.scratchPad];
      const newData = {...scratchPads.data[props.scratchPad], deltas};
      handleUpdateSchedulingScratchPad.mutate({extraKeys, record: newData, oldRecord: oldData});
    }

    const handleMxActionUndo = async (data) => {
      const {mxData} = data;
      const deltas = {...scratchPads.data[props.scratchPad].deltas};
      const idx = __.findIndex(deltas.updated.maintenance, {iopsScheduledMxUuid: mxData.iopsScheduledMxUuid});
      if (idx >= 0) {
        deltas.updated.maintenance.splice(idx, 1);
      }
      checkIfDeltaHasChanges(deltas);
      const oldData = scratchPads.data[props.scratchPad];
      const newData = {...scratchPads.data[props.scratchPad], deltas};
      handleUpdateSchedulingScratchPad.mutate({extraKeys, record: newData, oldRecord: oldData});
    }


    const handleResetScratchPad = async (data) => {
      const deltas = {...emptyDelta};
      const oldData = scratchPads.data[props.scratchPad];
      const newData = {...scratchPads.data[props.scratchPad], deltas};
      handleUpdateSchedulingScratchPad.mutate({extraKeys, record: newData, oldRecord: oldData});
      queryClient.invalidateQueries("SchedulingScratchPads");
      queryClient.invalidateQueries("ScratchPadUsers");
    }

    const handleRepaint = async () => {
      flags.current.dataLoaded++;
      setState({...state, dataLoaded: ++state.dataLoaded });
    }

    const handleRefresh = async (autoRefresh) => {
      console.log('handleRefresh');
      emptyCache()
      const startMonth = moment(state.startDate).startOf('month').format('YYYY-MM-DD HH:mm:ss');
      const startMonth2 = moment(state.startDate).startOf('month').add(1,'month').format('YYYY-MM-DD HH:mm:ss');
      const startMonth3 = moment(state.startDate).startOf('month').add(2,'month').format('YYYY-MM-DD HH:mm:ss');
      const {aircraftTrips, aircraftMx} = await getThreeMonthsData(startMonth, startMonth2, startMonth3, true, autoRefresh);
      queryClient.invalidateQueries("SchedulingScratchPads");
      queryClient.invalidateQueries("ScratchPadUsers");
      flags.current.dataLoaded++;
      setState({...state, dataLoaded: ++state.dataLoaded, aircraftTrips, aircraftMx });
      eventBus.trigger('FlightPlan.refreshDetailPanel');
    }

    const handleAutoRefresh = async () => {
      handleRefresh(true);
    }

    const handleRefreshLeg = async () => {
        console.log('handleRefreshLeg');
        eventBus.trigger('FlightPlan.refreshDetailPanel');
      if (tooltipState && tooltipState.current && tooltipState.current.uuid) {
        await refreshLegData(tooltipState.current.uuid);
        const startMonth = moment(state.startDate).startOf('month').format('YYYY-MM-DD HH:mm:ss');
        const startMonth2 = moment(state.startDate).startOf('month').add(1,'month').format('YYYY-MM-DD HH:mm:ss');
        const startMonth3 = moment(state.startDate).startOf('month').add(2,'month').format('YYYY-MM-DD HH:mm:ss');
        const {aircraftTrips, aircraftMx} = await getThreeMonthsData(startMonth, startMonth2, startMonth3);
        flags.current.dataLoaded++;
        setState({...state, dataLoaded: ++state.dataLoaded, aircraftTrips, aircraftMx });
      }
    }

    const handleApplyScratchPad = async (params) => {
      const {selection} = params;
      const oldData = scratchPads.data[props.scratchPad];
      const schedulingScratchPadUuid = oldData.SchedulingScratchPadUuid;
      try {
        SystemData.toggleLoadingProgress(true);
        const applied = await axios.put(`${apiSitePrefix}/schedulingscratchpads/apply/${schedulingScratchPadUuid}`, {selection});
        SystemData.toggleLoadingProgress(false);
        if (applied && applied.error) {
          SystemData.openAlert("Apply Failed", applied.errorMessage);
        }
      } catch(err) {
        SystemData.toggleLoadingProgress(false);
        SystemData.openAlert("Apply Failed", "An Unexpected error has occurred!");
      }
      await handleRefresh();
    }

    const handleTripMenuAction = (params) => {
      const {selectedAction, tripData, extraData} = params;
      tooltipState.current.uuid = tripData.uuid;
      if (__.isString(selectedAction)) {
        eventBus.trigger(`RouteView.TimeWindow.TripAction.${selectedAction}`, {tripData, extraData, selectedAction});
      }
    }

    const handleTripContextMenu = (params) => {
      const {trip, x, y} = params;
      tooltipState.current.uuid = trip.uuid;
      openTripContextMenu(trip, x, y, handleTripMenuAction, props.editing, props.canChange, props.canViewDetails);
    };

    const handleMxMenuAction = (params) => {
      const {selectedAction, mxData, extraData} = params;
      if (__.isString(selectedAction)) {
        eventBus.trigger(`RouteView.TimeWindow.MxAction.${selectedAction}`, {mxData, extraData});
      }
    }

    const handleMxContextMenu = (params) => {
      const {maintenance, x, y} = params;
      openMxContextMenu(maintenance, x, y, handleMxMenuAction, props.editing);
    };

    const handleTripActionEditCrew = (params) => {
      const {tripData} = params;
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("EditCrewDialog.open", tripData);
    }

    const handleTripActionEditPax = (params) => {
      const {tripData} = params;
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("EditPassengerDialog.open", tripData);
    }

    const handleTripActionEditFuel = (params) => {
      const {tripData, canEdit} = params;
      eventBus.trigger('RouteView.pause', true);
      setAircraftFuelLogDialogProps({
        ...aircraftFuelLogDialogProps,
        open: true,
        legRecord: {...tripData, aircraftReg: tripData.aircraftId},
        canEdit
      })
    }

    const handleTripActionEditFuelPolicy = (params) => {
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("FuelPolicyDialog.open", params);
    }

    const handleTripActionEditServices = (params) => {
      const {tripData} = params;
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("EditServicesDialog.open", tripData);
    }

    const handleTripActionEditCatering = async (params) => {
      const {tripData} = params;

      let supplierUuid = null;
      let orderTemplateUuid = null;
      let orderEmailTemplate = null;
      const defaultServiceTypes = await fetchDefaultServiceTypes({queryClient, extraKeys: [tripData.originAirportCode], useCache: false});
      if (defaultServiceTypes && Array.isArray(defaultServiceTypes)) {
        const cateringService = __.find(defaultServiceTypes, {serviceCode: "CATERING"});
        if (cateringService && __.has(cateringService, "companyUuid"))
          supplierUuid = cateringService.companyUuid;
        if (cateringService && __.has(cateringService, "orderTemplate"))
          orderTemplateUuid = cateringService.orderTemplate;
        if (cateringService && __.has(cateringService, "orderEmailTemplate"))
          orderEmailTemplate = cateringService.orderEmailTemplate;
      }

      const tripLegServices = await fetchTripLegServices({queryClient, extraKeys: [tripData.tripLegUuid], useCache: false});
      const cateringService = __.find(tripLegServices, {serviceCode: "CATERING"});
      if (cateringService && cateringService.serviceProviderUuid) {
        supplierUuid = cateringService.serviceProviderUuid;
      }
      if (supplierUuid)
        tripData["supplierUuid"] = supplierUuid;
      if (orderTemplateUuid)
        tripData["orderTemplateUuid"] = orderTemplateUuid;
      if (orderTemplateUuid)
        tripData["orderEmailTemplate"] = orderEmailTemplate;

        eventBus.trigger('RouteView.pause', true);
        eventBus.trigger("EditCateringDialog.open", tripData);
    }

    const handleTripActionEditCargo = (params) => {
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("EditCargoDialog.open", params);
    }

    const handleTripActionEditUldStack = (params) => {
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("EditUldStacksDialog.open", params);
    }

    const handleTripActionEditPayload = (params) => {
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("EditActualWeightDialog.open", params);
    }

    const handleTripActionAddEvent = (params) => {
      let noteParams = params;
      if (!__.has(params, 'title')) {
        const {tripData} = params;
        const noteType = "TRIP_LEG:FLIGHT_EVENT";
        noteParams = {tripLegUuid: tripData.uuid, noteType, title: `Flight Delay for  ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUtc).format("D MMM HH:mm")}`, tripData};
      }
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("TripLegEventDialog.open", noteParams);
    }

    const handleTripActionAdjustDelay = async (params) => {
      try {
        const adjusted = await axios.put(`${apiSitePrefix}/tripleg/adjustdelay/${params.tripLegUuid}`);
        if (adjusted && adjusted.error) {
          SystemData.openAlert("Apply Failed", adjusted.errorMessage);
        }
      } catch(err) {
        console.error("Apply Failed Unexpectedly : ", err);
        SystemData.openAlert("Apply Failed", "An Unexpected error has occurred!");
      }
      queryClient.invalidateQueries(['TripLegs', params.tripUuid, params.tripLegUuid]);
      queryClient.getQueryCache().queries.filter(
        (query)=>{
          return query.queryKey[0] === 'Notes' && query.queryKey[query.queryKey.length - 1] === '_cached'
        }
      ).forEach(cache => {
        queryClient.resetQueries(cache.queryKey, true)
      });
    await handleRefresh();
    }

    const handleTripActionAddNote = (params) => {
      let noteParams = params;
      if (!__.has(params, 'title')) {
        const {tripData} = params;
        const noteType = "TRIP_LEG:FLIGHT";
        noteParams = {tripLegUuid: tripData.uuid, noteType, title: `Flight Note for  ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUTC).format("D MMM")}`};
      }
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("TripLegNoteDialog.open", noteParams);
    }

    const handleTripActionEditNote = (params) => {
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("TripLegNoteDialog.open", params);
    }

    const handleTripActionAircraftMovement = (params) => {
      const {tripData} = params;
      const tripLegUuid = tripData.uuid; //moment.utc(tripData.scheduledDepartureTimeUtc).isAfter(moment.utc()) ? null : tripData.uuid;
      setCaptureMovementDialog({captureMovement: true, aircraft: tripData.aircraftReg, airlineCode: tripData.airlineCode, flightNo: tripData.flightNo, originAirportCode: tripData.originAirportCode, destinationAirportCode: tripData.destinationAirportCode, tripLegUuid: tripLegUuid});
    }

    const handleTripActionEditChecklistItem = (params) => {
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("TripLegChecklistItemDialog.open", params);
    }

    const handleReturnToStand = (params) => {
      let noteParams = params;
      if (!__.has(params, 'title')) {
        const {tripData} = params;
        const noteType = "TRIP_LEG:FLIGHT_RETURN_TO_STAND";
        noteParams = {tripLegUuid: tripData.uuid, noteType, title: `Flight ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUtc).format("D MMM HH:mm")} Returned to Stand`, tripData};
      }
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("TripLegReturnToStandDialog.open", noteParams);
    }

    const handleDiversion = (params) => {
      let noteParams = params;
      if (!__.has(params, 'title')) {
        const {tripData} = params;
        const noteType = "TRIP_LEG:FLIGHT_DIVERSION";
        noteParams = {tripLegUuid: tripData.uuid, noteType, title: `Flight Diversion for ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUtc).format("D MMM HH:mm")}`, tripData};
      }
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("TripLegDiversionDialog.open", noteParams);
    }

    const handleMessages = (params) => {
      handleFlightDataEvent(params, "EditFlightMessages.open");      
    }

    const handleUldMessages = (params) => {
      handleFlightDataEvent(params, "ViewUldMessages.open");      
    }

    const handleUldDocuments = (params) => {
      handleFlightDataEvent(params, "ViewUldDocuments.open");      
    }

    const handleDocuments = (params) => {
      handleFlightDataEvent(params, "EditFlightDocuments.open");      
    }

    const handleFlightDataEvent = (params, event) => {
      const {tripData} = params;
      axios.get(`${apiSitePrefix}/triplegs/getTripLeg/${tripData.uuid}`)
      .then((response) => {
        if (!response.data) {
          SystemData.alert("Error", `Could not retrieve Flight Data. Server is not responding`);
          return null;
        } else if (Array.isArray(response.data)) {
          if (response.data.length < 1) {
            SystemData.alert("Error", `Could not retrieve Flight Data. Flight was not found.`);
          } else {
            const flight = response.data[0];
            eventBus.trigger(event, flight);
          }
        } else {
          SystemData.alert("Error", `Could not retrieve Flight Data. Server returned ${response.data.error}`);
          return null;
        }
      })
      .catch(err => {
        SystemData.alert("Error", `Could not retrieve Flight Data. An unexpected error has occurred`);
      })
    }

    const getUserScratchPad = async(SchedulingScratchPadUuid) => {
      const record = await axios.get(
        `${apiSitePrefix}/schedulingscratchpad/get/${SchedulingScratchPadUuid}`
      );
      return record?.data;
    }

    const copyAllChangesToScratchPad = async (scratchPad, toScratchPadRef) => {
      const updated = scratchPad?.deltas?.updated;
      const {trips, scheduled, maintenance} = updated;

      const {SchedulingScratchPadUuid} = toScratchPadRef;
      const toScratchPad = await getUserScratchPad(SchedulingScratchPadUuid);

      const deltas = toScratchPad?.deltas || emptyDelta;

      if (Array.isArray(trips)) {
        trips.forEach(tripLeg => {
          const existingIdx = __.findIndex(deltas.updated['trips'], { uuid: tripLeg.uuid });
          if (existingIdx > -1) {
            deltas.updated['trips'][existingIdx] = tripLeg;
          } else {
            deltas.updated['trips'].push(tripLeg);
          }  
        })
      }
      if (Array.isArray(scheduled)) {
        scheduled.forEach(tripLeg => {
          const existingIdx = __.findIndex(deltas.updated['scheduled'], { uuid: tripLeg.uuid });
          if (existingIdx > -1) {
            deltas.updated['scheduled'][existingIdx] = tripLeg;
          } else {
            deltas.updated['scheduled'].push(tripLeg);
          }  
        })
      }
      if (Array.isArray(maintenance)) {
        maintenance.forEach(mx => {
          const existingIdx = __.findIndex(deltas.updated['maintenance'], { uuid: mx.iopsScheduledMxUuid });
          if (existingIdx > -1) {
            deltas.updated['maintenance'][existingIdx] = mx;
          } else {
            deltas.updated['maintenance'].push(mx);
          }  
        })
      }

      checkIfDeltaHasChanges(deltas);
      const newData = { ...toScratchPad, deltas };
      validateDeltas(deltas);
      handleUpdateSchedulingScratchPad.mutate({extraKeys, record: newData, oldRecord: toScratchPad });
    }

    const copyChangesToScratchPad = async (recordType, scratchPad, tripUuid, toScratchPadRef, uuid) => {

      const {SchedulingScratchPadUuid} = toScratchPadRef;
      const toScratchPad = await getUserScratchPad(SchedulingScratchPadUuid);

      const tripLegs = __.filter(scratchPad?.deltas?.updated[recordType] || [], { tripUuid });
      const deltas = toScratchPad?.deltas || emptyDelta;
      for (let i = 0; i < tripLegs.length; i++) {
        const tripLeg = tripLegs[i];
        const existingIdx = __.findIndex(deltas.updated[recordType], { uuid: tripLeg.uuid });
        if (existingIdx > -1) {
          deltas.updated[recordType][existingIdx] = tripLeg;
        } else {
          deltas.updated[recordType].push(tripLeg);
        }
      }
      checkIfDeltaHasChanges(deltas);
      const newData = { ...toScratchPad, deltas };
      validateDeltas(deltas);
      handleUpdateSchedulingScratchPad.mutate({extraKeys, record: newData, oldRecord: toScratchPad });
    }

    const handleCopyAllToScratchPad = (params) => {
      const {extraData: toScratchPad} = params;
      const scratchPad = scratchPads.data[props.scratchPad];

      copyAllChangesToScratchPad(scratchPad, toScratchPad).then(()=>{
        SystemData.openAlert(
          "Copied",
          `All changes have been copied to Scratch Pad ${toScratchPad.scratchPadNo + 1}`
        );  
      });
    }

    const handleCopyToScratchPad = (params) => {
      const {extraData: toScratchPad, tripData} = params;
      const {tripUuid, uuid, type} = tripData;
      const scratchPad = scratchPads.data[props.scratchPad];
      const recordType = type === 'SCHEDULED' ? 'scheduled' : 'trips';

      copyChangesToScratchPad(recordType, scratchPad, tripUuid, toScratchPad, uuid).then(()=> {
        SystemData.openAlert(
          "Copied",
          `Changes have been copied to Scratch Pad ${toScratchPad.scratchPadNo + 1}`
        );  
      });
    }

    const handleMoveToScratchPad = (params) => {
      const {extraData: toScratchPad, tripData} = params;
      const {tripUuid, uuid, type} = tripData;
      const scratchPad = scratchPads.data[props.scratchPad];
      const recordType = type === 'SCHEDULED' ? 'scheduled' : 'trips';

      copyChangesToScratchPad(recordType, scratchPad, tripUuid, toScratchPad, uuid).then(()=> {
        const deltas = scratchPad.deltas;
        const records = __.filter(deltas.updated[recordType], (record) => record.tripUuid !== tripUuid);
        deltas.updated[recordType] = records;
        checkIfDeltaHasChanges(deltas);
  
        const newData = { ...scratchPad, deltas };
        validateDeltas(deltas);
        handleUpdateSchedulingScratchPad.mutate({extraKeys, record: newData, oldRecord: scratchPad });
  
        SystemData.openAlert(
          "Moved",
          `Changes have been moved to Scratch Pad ${toScratchPad.scratchPadNo + 1}`
        );  
      });
    }

    const handleCopytoClipboard = (params) => {
      const {selectedAction, tripData} = params;
      const {tripUuid, uuid, type} = tripData;

      const tableStyles = `<style>
        table, th, td {
          border: 1px solid black;
          border-collapse: collapse;
        }
        th {
          background-color: #e95300;
        }
        th, td {
          padding: 5px;
        }
      </style>
      `;

      const buildTrip = (tripData, type) => {
        const {airlineCode, flightNo, scheduledDepartureTimeUtc, scheduledArrivalTimeUtc, originAirportCode, destinationAirportCode} = tripData;
        const flightDate = moment.utc(scheduledDepartureTimeUtc).format('DDMMMYYYY').toUpperCase();
        const departureTime = moment.utc(scheduledDepartureTimeUtc).format('HH:mm');
        const arrivalTime = moment.utc(scheduledArrivalTimeUtc).format('HH:mm');
        const flightNumber = `${airlineCode}${flightNo}`.padEnd(8, ' ');

        if (type === 'html') {
          return `<tr><td>${flightDate}</td><td>${flightNumber}</td><td>${originAirportCode}</td><td>STD ${departureTime}</td><td>${arrivalTime} STA</td><td>${destinationAirportCode}</td></tr>`;
        }
        return `${flightDate} ${flightNumber} ${originAirportCode} STD ${departureTime}  ${arrivalTime} STA ${destinationAirportCode}`;
      }

      switch (selectedAction) {
        case 'copyFlightAsText':
          navigator.clipboard.writeText(buildTrip(tripData, 'text'));
          break;
        case 'copyFlightAsHtml':
          const tripLine = buildTrip(tripData, 'html');
          const tableHeading = `<tr><th>Date</th><th>Flight</th><th>Origin</th><th>STD</th><th>STA</th><th>Dest.</th></tr>`;
          const table = `${tableStyles}<table>${tableHeading}${tripLine}</table>`;
          const blob = new Blob([table], { type: 'text/html' });
            // eslint-disable-next-line no-undef
          const clipboardItem = new ClipboardItem({ 'text/html': blob });
          navigator.clipboard.write([clipboardItem]);
          break;
        case 'copyTripAsHtml':
          let deltas = {...scratchPads.data[props.scratchPad].deltas};
          const tripLegs = getTripLegs(tripData.tripUuid, props.editing?deltas:emptyDelta);
          if (!tripLegs) return;
          const tripLines = tripLegs.map((tripData) => buildTrip(tripData, 'html'));
          const tableHeading2 = `<tr><th>Date</th><th>Flight</th><th>Origin</th><th>STD</th><th>STA</th><th>Dest.</th></tr>`;
          const table2 = `${tableStyles}<table>${tableHeading2}${tripLines.join('')}</table>`;
          const blob2 = new Blob([table2], { type: 'text/html' });
            // eslint-disable-next-line no-undef
          const clipboardItem2 = new ClipboardItem({ 'text/html': blob2 });
          navigator.clipboard.write([clipboardItem2]);
          break;
        case 'copyTripAsText':
        default:
          let deltas2 = {...scratchPads.data[props.scratchPad].deltas};
          const tripLegs2 = getTripLegs(tripData.tripUuid, props.editing?deltas2:emptyDelta);
          if (!tripLegs2) return;
          const tripLines2 = tripLegs2.map((tripData) => buildTrip(tripData, 'text'));
          navigator.clipboard.writeText(tripLines2.join('\n'));
          break;
      }
    };

    const handleTripActionEditStd = (params) => {
      const {tripData} = params;
      eventBus.trigger('RouteView.pause', true);
      eventBus.trigger("EditTripLegStdDialog.open", tripData);
    }

    const cancelDiversion = async(params) => {
      try {
        const adjusted = await axios.put(`${apiSitePrefix}/tripleg/canceldiversion/${params.uuid}`);
        if (adjusted && adjusted.error) {
          SystemData.openAlert("Cancel Diversion Failed", adjusted.errorMessage);
        }
      } catch(err) {
        if (err?.response?.data?.error && err?.response?.data?.errorMessage) {
          SystemData.openAlert("Cancel Diversion Failed", err.response.data.errorMessage);
          return;          
        }
        console.error("Cancel Diversion Failed Unexpectedly : ", err);
        SystemData.openAlert("Cancel Diversion Failed", "An Unexpected error has occurred!");
      }
      queryClient.invalidateQueries(['TripLegs', params.tripUuid, params.uuid]);
      queryClient.getQueryCache().queries.filter(
        (query)=>{
          return query.queryKey[0] === 'Notes' && query.queryKey[query.queryKey.length - 1] === '_cached'
        }
      ).forEach(cache => {
        queryClient.resetQueries(cache.queryKey, true)
      });
      await handleRefreshLeg();
    }

    const handleCancelDiversion = (params) => {
      const {tripData} = params;

      SystemData.confirm(
        `Cancel Diversion`,
        `Are you sure you wish to cancel the Flights Diversion?'`,
        [
          {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}},
          {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
        ],
        (response) => {
          if (response) {
            cancelDiversion(tripData)
          }
        }
      );
    }

    const handleToggleTripMultiSelect = (params) => {
      console.log('Toggle Trip', JSON.stringify(params, null, 2));
      debugger;
    }

    const handleToggleLegMultiSelect = (params) => {
      console.log('Toggle Leg', JSON.stringify(params, null, 2));
      debugger;
    }

    const handleSearch = async (searchValue) => {
      if (searchValue.length < 3) {
        return;
      }

      if (!scrollRef.current) {
        return;
      }

      let dateTime = moment.utc().toISOString();

      if (scrollRef.current) {
        const oldBlockSize = state.blockSize;
        const offset = state.clientWidth / 2;
        const blockInMiddle = (scrollRef.current.scrollLeft + (offset - offsets[oldBlockSize])) / oldBlockSize;
        const scrollTime = moment.utc(state.startDate).add(blockInMiddle + 1, 'hour');
        const newMinutes = scrollTime.get('minutes');
        const fiveMinDiff = newMinutes % 5;
        dateTime = scrollTime.subtract(fiveMinDiff, 'minute').toISOString();
      }

      const isAlphaOnly = /^[a-zA-Z]+$/.test(searchValue);
      const isAlphaNumeric = /^[a-zA-Z0-9]+$/.test(searchValue);

      let scrollToDate = null;
      if (searchValue.length === 3 && isAlphaOnly) {
        Object.keys(monthsTripData).forEach(monthKey => {
          if (monthsTripData[monthKey]?.data?.data?.flights && Array.isArray(Object.keys(monthsTripData[monthKey]?.data?.data?.flights))){
            const aircraft = Object.keys(monthsTripData[monthKey].data.data.flights);
            for (let i = 0; i < aircraft.length; i++) {
              if (Array.isArray(monthsTripData[monthKey].data.data.flights[aircraft[i]])) {
                const nextFlight = __.find(monthsTripData[monthKey].data.data.flights[aircraft[i]], (trip)=>trip.destinationAirportCode === searchValue && moment.utc(trip.scheduledArrivalTimeUtc).isAfter(moment.utc(dateTime)));
                if (nextFlight && (scrollToDate === null || moment.utc(nextFlight.scheduledArrivalTimeUtc).isBefore(moment.scrollToDate))) {
                  scrollToDate = moment.utc(nextFlight.scheduledArrivalTimeUtc).toISOString();
                  eventBus.trigger("RouteView.TimeWindow.TripAction.pointAtTripLeg", {tripLegKey: nextFlight.uuid});
                }
              }
            }
          }
        });
      }
      if (searchValue.length >= 9 && isAlphaNumeric && !isAlphaOnly && searchValue.startsWith((process.env.REACT_APP_TRIP_PREFIX || 'MAG'))) {
        Object.keys(monthsTripData).forEach(monthKey => {
          if (monthsTripData[monthKey]?.data?.data?.flights && Array.isArray(Object.keys(monthsTripData[monthKey]?.data?.data?.flights))){
            const aircraft = Object.keys(monthsTripData[monthKey].data.data.flights);
            for (let i = 0; i < aircraft.length; i++) {
              if (Array.isArray(monthsTripData[monthKey].data.data.flights[aircraft[i]])) {
                const nextFlight = __.find(monthsTripData[monthKey].data.data.flights[aircraft[i]], (trip)=>(`${trip.tripNo}` === searchValue || `MAG${trip.tripNo}` === searchValue));
                if (nextFlight && scrollToDate === null) {
                  scrollToDate = moment.utc(nextFlight.scheduledDepartureTimeUtc).toISOString();
                  eventBus.trigger("RouteView.TimeWindow.TripAction.pointAtTripLeg", {tripLegKey: nextFlight.uuid});
                }
              }
            }
          }
        });
      }
      if (searchValue.length >= 3 && isAlphaNumeric && !isAlphaOnly && !searchValue.startsWith(process.env.REACT_APP_TRIP_PREFIX || 'MAG')) {
        Object.keys(monthsTripData).forEach(monthKey => {
          if (monthsTripData[monthKey]?.data?.data?.flights && Array.isArray(Object.keys(monthsTripData[monthKey]?.data?.data?.flights))){
            const aircraft = Object.keys(monthsTripData[monthKey].data.data.flights);
            for (let i = 0; i < aircraft.length; i++) {
              if (Array.isArray(monthsTripData[monthKey].data.data.flights[aircraft[i]])) {
                const nextFlight = __.find(monthsTripData[monthKey].data.data.flights[aircraft[i]], (trip)=>`${trip.airlineCode}${trip.flightNo}` === searchValue && moment.utc(trip.scheduledDepartureTimeUtc).isAfter(moment.utc(dateTime)));
                if (nextFlight && (scrollToDate === null || moment.utc(nextFlight.scheduledDepartureTimeUtc).isBefore(moment.scrollToDate))) {
                  scrollToDate = moment.utc(nextFlight.scheduledDepartureTimeUtc).toISOString();
                  eventBus.trigger("RouteView.TimeWindow.TripAction.pointAtTripLeg", {tripLegKey: nextFlight.uuid});
                }
              }
            }
          }
        });
      }
      if (scrollToDate !== null) {
        console.log("scrollToDate:", scrollToDate);
        eventBus.trigger('RouteView.scrollTo', scrollToDate);
      }
    };

    eventBus.bind('RouteView.search', handleSearch);
    eventBus.bind('RouteView.zoomIn', handleZoomIn);
    eventBus.bind('RouteView.zoomOut', handleZoomOut);
    eventBus.bind('RouteView.zoomTo', handleZoomTo);
    eventBus.bind('RouteView.scrollTo', handleScrollTo);
    eventBus.bind('RouteView.scrollForward', handleScrollForward);
    eventBus.bind('RouteView.scrollBackward', handleScrollBackward);
    eventBus.bind('RouteView.scrollOffset', handleScrollOffset);
    eventBus.bind('RouteView.resetScratchPad', handleResetScratchPad);
    eventBus.bind('RouteView.applyScratchPad', handleApplyScratchPad);
    eventBus.bind('RouteView.refresh', handleRefresh);
    eventBus.bind('RouteView.autoRefresh', handleAutoRefresh);
    eventBus.bind('RouteView.refreshLeg', handleRefreshLeg);
    eventBus.bind('RouteView.repaint', handleRepaint);
    eventBus.bind('RouteView.TimeWindow.loaded', handleTimeWindowLoaded);
    eventBus.bind('RouteView.TimeWindow.atStart', handleTimeWindowAtStart);
    eventBus.bind('RouteView.TimeWindow.atEnd', handleTimeWindowAtEnd);
    eventBus.bind('RouteView.TimeWindow.droppedMx', handleTimeWindowDroppedMx);
    eventBus.bind('RouteView.TimeWindow.droppedTrip', handleTimeWindowDroppedTrip);
    eventBus.bind('RouteView.TimeWindow.TripContextMenu', handleTripContextMenu);
    eventBus.bind('RouteView.addTrip', handleTripActionAddTrip);
    eventBus.bind('RouteView.TimeWindow.TripAction.editTrip', handleTripActionEditTrip);
    eventBus.bind('RouteView.TimeWindow.TripAction.editScheduledTime', handleTripActionEditStd);
    eventBus.bind('RouteView.TimeWindow.TripAction.editScheduledTrip', handleTripActionEditScheduledTrip);
    eventBus.bind('RouteView.TimeWindow.TripAction.undo', handleTripActionUndo);
    eventBus.bind('RouteView.TimeWindow.TripAction.undoTrip', handleTripActionUndoTrip);
    eventBus.bind('RouteView.TimeWindow.TripAction.addMovement', handleTripActionAircraftMovement);
    eventBus.bind('RouteView.TimeWindow.TripAction.changeTripsAircraft', handleChangeTripsAircraft);
    eventBus.bind('RouteView.TimeWindow.TripAction.cancelTrip', handleTripActionCancelTrip);
    eventBus.bind('RouteView.TimeWindow.TripAction.downloadTripSheet', handleTripActionDownloadTripSheet);
    eventBus.bind('RouteView.TimeWindow.TripAction.emailTripSheet', handleTripActionEmailTripSheet);
    eventBus.bind('RouteView.TimeWindow.TripAction.downloadSectorSheet', handleTripActionDownloadSectorSheet);
    eventBus.bind('RouteView.TimeWindow.TripAction.emailSectorSheet', handleTripActionEmailSectorSheet);
    eventBus.bind('RouteView.TimeWindow.TripAction.editCrew', handleTripActionEditCrew);
    eventBus.bind('RouteView.TimeWindow.TripAction.editPax', handleTripActionEditPax);
    eventBus.bind('RouteView.TimeWindow.TripAction.editFuel', handleTripActionEditFuel);
    eventBus.bind('RouteView.TimeWindow.TripAction.editFuelPolicy', handleTripActionEditFuelPolicy);
    eventBus.bind('RouteView.TimeWindow.TripAction.editServices', handleTripActionEditServices);
    eventBus.bind('RouteView.TimeWindow.TripAction.editCatering', handleTripActionEditCatering);
    eventBus.bind('RouteView.TimeWindow.TripAction.editCargo', handleTripActionEditCargo);
    eventBus.bind('RouteView.TimeWindow.TripAction.editUldStack', handleTripActionEditUldStack);
    eventBus.bind('RouteView.TimeWindow.TripAction.editPayload', handleTripActionEditPayload);
    eventBus.bind('RouteView.TimeWindow.TripAction.addEvent', handleTripActionAddEvent);
    eventBus.bind('RouteView.TimeWindow.TripAction.adjustDelay', handleTripActionAdjustDelay);
    eventBus.bind('RouteView.TimeWindow.TripAction.addNote', handleTripActionAddNote);
    eventBus.bind('RouteView.TimeWindow.TripAction.editNote', handleTripActionEditNote);
    eventBus.bind('RouteView.TimeWindow.TripAction.editChecklistItem', handleTripActionEditChecklistItem);
    eventBus.bind('RouteView.TimeWindow.TripAction.copyAllToScratchPad', handleCopyAllToScratchPad);
    eventBus.bind('RouteView.TimeWindow.TripAction.copyToScratchPad', handleCopyToScratchPad);
    eventBus.bind('RouteView.TimeWindow.TripAction.moveToScratchPad', handleMoveToScratchPad);
    eventBus.bind('RouteView.TimeWindow.TripAction.returnToStand', handleReturnToStand);
    eventBus.bind('RouteView.TimeWindow.TripAction.diversion', handleDiversion);
    eventBus.bind('RouteView.TimeWindow.TripAction.cancelDiversion', handleCancelDiversion);
    eventBus.bind('RouteView.TimeWindow.TripAction.documents', handleDocuments);
    eventBus.bind('RouteView.TimeWindow.TripAction.copyFlightAsText', handleCopytoClipboard);
    eventBus.bind('RouteView.TimeWindow.TripAction.copyFlightAsHtml', handleCopytoClipboard);
    eventBus.bind('RouteView.TimeWindow.TripAction.copyTripAsText', handleCopytoClipboard);
    eventBus.bind('RouteView.TimeWindow.TripAction.copyTripAsHtml', handleCopytoClipboard);
    eventBus.bind('RouteView.TimeWindow.MxAction.undo', handleMxActionUndo);
    eventBus.bind('RouteView.TimeWindow.MxContextMenu', handleMxContextMenu);
    eventBus.bind('RouteView.TimeWindow.toggleTripMultiSelect', handleToggleTripMultiSelect);
    eventBus.bind('RouteView.TimeWindow.toggleLegMultiSelect', handleToggleLegMultiSelect);
    eventBus.bind('RouteView.TimeWindow.TripAction.uldDocuments', handleUldDocuments);
    eventBus.bind('RouteView.TimeWindow.TripAction.messages', handleMessages);
    eventBus.bind('RouteView.TimeWindow.TripAction.uldMessages', handleUldMessages);
    eventBus.bind('RouteView.TimeWindow.TripAction.pointAtTripLeg', handleTripLegPointer);

    if (!defaultValues || __.isEmpty(defaultValues))
      getTripSheetDefaultValues();

    return () => {
      eventBus.unbind('RouteView.search', handleSearch);
      eventBus.unbind('RouteView.zoomIn', handleZoomIn);
      eventBus.unbind('RouteView.zoomOut', handleZoomOut);
      eventBus.unbind('RouteView.zoomTo', handleZoomTo);
      eventBus.unbind('RouteView.scrollTo', handleScrollTo);
      eventBus.unbind('RouteView.scrollForward', handleScrollForward);
      eventBus.unbind('RouteView.scrollBackward', handleScrollBackward);
      eventBus.unbind('RouteView.scrollOffset', handleScrollOffset);
      eventBus.unbind('RouteView.resetScratchPad', handleResetScratchPad);
      eventBus.unbind('RouteView.applyScratchPad', handleApplyScratchPad);
      eventBus.unbind('RouteView.refresh', handleRefresh);
      eventBus.unbind('RouteView.autoRefresh', handleAutoRefresh);
      eventBus.unbind('RouteView.refreshLeg', handleRefreshLeg);
      eventBus.unbind('RouteView.repaint', handleRepaint);
      eventBus.unbind('RouteView.TimeWindow.loaded', handleTimeWindowLoaded);
      eventBus.unbind('RouteView.TimeWindow.atStart', handleTimeWindowAtStart);
      eventBus.unbind('RouteView.TimeWindow.atEnd', handleTimeWindowAtEnd);
      eventBus.unbind('RouteView.TimeWindow.droppedMx', handleTimeWindowDroppedMx);
      eventBus.unbind('RouteView.TimeWindow.droppedTrip', handleTimeWindowDroppedTrip);
      eventBus.unbind('RouteView.TimeWindow.TripContextMenu', handleTripContextMenu);
      eventBus.unbind('RouteView.addTrip', handleTripActionAddTrip);
      eventBus.unbind('RouteView.TimeWindow.TripAction.editTrip', handleTripActionEditTrip);
      eventBus.unbind('RouteView.TimeWindow.TripAction.editScheduledTime', handleTripActionEditStd);
      eventBus.unbind('RouteView.TimeWindow.TripAction.editScheduledTrip', handleTripActionEditScheduledTrip);
      eventBus.unbind('RouteView.TimeWindow.TripAction.undo', handleTripActionUndo);
      eventBus.unbind('RouteView.TimeWindow.TripAction.undoTrip', handleTripActionUndoTrip);
      eventBus.unbind('RouteView.TimeWindow.TripAction.addMovement', handleTripActionAircraftMovement);
      eventBus.unbind('RouteView.TimeWindow.TripAction.changeTripsAircraft', handleChangeTripsAircraft);
      eventBus.unbind('RouteView.TimeWindow.TripAction.cancelTrip', handleTripActionCancelTrip);
      eventBus.unbind('RouteView.TimeWindow.TripAction.downloadTripSheet', handleTripActionDownloadTripSheet);
      eventBus.unbind('RouteView.TimeWindow.TripAction.emailTripSheet', handleTripActionEmailTripSheet);
      eventBus.unbind('RouteView.TimeWindow.TripAction.downloadSectorSheet', handleTripActionDownloadSectorSheet);
      eventBus.unbind('RouteView.TimeWindow.TripAction.emailSectorSheet', handleTripActionEmailSectorSheet);
      eventBus.unbind('RouteView.TimeWindow.TripAction.editCrew', handleTripActionEditCrew);
      eventBus.unbind('RouteView.TimeWindow.TripAction.editPax', handleTripActionEditPax);
      eventBus.unbind('RouteView.TimeWindow.TripAction.editFuel', handleTripActionEditFuel);
      eventBus.unbind('RouteView.TimeWindow.TripAction.editFuelPolicy', handleTripActionEditFuelPolicy);
      eventBus.unbind('RouteView.TimeWindow.TripAction.editServices', handleTripActionEditServices);
      eventBus.unbind('RouteView.TimeWindow.TripAction.editCatering', handleTripActionEditCatering);
      eventBus.unbind('RouteView.TimeWindow.TripAction.editCargo', handleTripActionEditCargo);
      eventBus.unbind('RouteView.TimeWindow.TripAction.editUldStack', handleTripActionEditUldStack);
      eventBus.unbind('RouteView.TimeWindow.TripAction.editPayload', handleTripActionEditPayload);
      eventBus.unbind('RouteView.TimeWindow.TripAction.addEvent', handleTripActionAddEvent);
      eventBus.unbind('RouteView.TimeWindow.TripAction.adjustDelay', handleTripActionAdjustDelay);
      eventBus.unbind('RouteView.TimeWindow.TripAction.addNote', handleTripActionAddNote);
      eventBus.unbind('RouteView.TimeWindow.TripAction.editNote', handleTripActionEditNote);
      eventBus.unbind('RouteView.TimeWindow.TripAction.editChecklistItem', handleTripActionEditChecklistItem);
      eventBus.unbind('RouteView.TimeWindow.TripAction.copyAllToScratchPad', handleCopyAllToScratchPad);
      eventBus.unbind('RouteView.TimeWindow.TripAction.copyToScratchPad', handleCopyToScratchPad);
      eventBus.unbind('RouteView.TimeWindow.TripAction.moveToScratchPad', handleMoveToScratchPad);
      eventBus.unbind('RouteView.TimeWindow.TripAction.returnToStand', handleReturnToStand);
      eventBus.unbind('RouteView.TimeWindow.TripAction.diversion', handleDiversion);
      eventBus.unbind('RouteView.TimeWindow.TripAction.cancelDiversion', handleCancelDiversion);
      eventBus.unbind('RouteView.TimeWindow.TripAction.documents', handleDocuments);
      eventBus.unbind('RouteView.TimeWindow.TripAction.copyFlightAsText', handleCopytoClipboard);
      eventBus.unbind('RouteView.TimeWindow.TripAction.copyFlightAsHtml', handleCopytoClipboard);
      eventBus.unbind('RouteView.TimeWindow.TripAction.copyTripAsText', handleCopytoClipboard);
      eventBus.unbind('RouteView.TimeWindow.TripAction.copyTripAsHtml', handleCopytoClipboard);
      eventBus.unbind('RouteView.TimeWindow.MxAction.undo', handleMxActionUndo);
      eventBus.unbind('RouteView.TimeWindow.MxContextMenu', handleMxContextMenu);
      eventBus.unbind('RouteView.TimeWindow.toggleTripMultiSelect', handleToggleTripMultiSelect);
      eventBus.unbind('RouteView.TimeWindow.toggleLegMultiSelect', handleToggleLegMultiSelect);
      eventBus.unbind('RouteView.TimeWindow.TripAction.uldDocuments', handleUldDocuments);
      eventBus.unbind('RouteView.TimeWindow.TripAction.messages', handleMessages);
      eventBus.unbind('RouteView.TimeWindow.TripAction.uldMessages', handleUldMessages);
      eventBus.unbind('RouteView.TimeWindow.TripAction.pointAtTripLeg', handleTripLegPointer);
    }
  }, [eventBus, props.startDate, scrollRef, state, props.scratchPad, props.estimatedMode, props.nudgeMode, scratchPads.data, handleUpdateSchedulingScratchPad, validateDeltas, emptyDelta, queryClient, SystemData, setSetting, props.editing, openEditSchedulePlanning, openAddTrip, openTripContextMenu, openMxContextMenu, aircraftFuelLogDialogProps])

//  }, [eventBus, props.startDate, scrollRef, state, props.scratchPad, props.estimatedMode, props.nudgeMode, scratchPads.data, handleUpdateSchedulingScratchPad, validateDeltas, openEditTrip, emptyDelta, queryClient, SystemData, setSetting, props.editing, openEditSchedulePlanning, openAddTrip, openTripContextMenu, openMxContextMenu, aircraftFuelLogDialogProps])
//}, [eventBus, props.startDate, scrollRef, state, props.scratchPad, props.estimatedMode, props.nudgeMode, scratchPads.data, handleUpdateSchedulingScratchPad, validateDeltas, openEditTrip, emptyDelta, queryClient, SystemData])

  useEffect(() => {
    let aircraftTrips = state.aircraftTrips;
    if (!props.editing || state.scratchPad !== props.scratchPad) {
      aircraftTrips = __.pick(state.aircraftTrips, __.filter(Object.keys(state.aircraftTrips), (aircraftReg) => state.aircraftTrips[aircraftReg] && Array.isArray(state.aircraftTrips[aircraftReg]) && state.aircraftTrips[aircraftReg].length > 0));
    }
    if (props.editing) {
      const scratchPadAircraft = props.editing && scratchPads && Array.isArray(scratchPads.data) && scratchPads.data[props.scratchPad] && scratchPads.data[props.scratchPad].deltas && scratchPads.data[props.scratchPad].deltas.updated && scratchPads.data[props.scratchPad].deltas.updated.trips?__.uniq(scratchPads.data[props.scratchPad].deltas.updated.trips.map(trip => trip.aircraftReg)):[];
      if (scratchPadAircraft) {
        scratchPadAircraft.forEach(aircraftReg => {
          if (!__.has(aircraftTrips,aircraftReg)){
            aircraftTrips[aircraftReg]=[];
          }
        });
      }
    }
    if (Object.keys(aircraftTrips).length !== Object.keys(state.aircraftTrips).length) {
      //console.log('Aircraft Changed');
      setState({...state, aircraftTrips, scratchPad:props.scratchPad});
    }
},[props.editing, scratchPads, state, state.aircraftTrips, props.scratchPad]);

  useEffect(()=>{
    const startTime = props.startDate; ;
    const endTime = props.endDate;;
    const startDate = props.startDate;
    if (!state.initialized) {
      console.log('Initializing');
      emptyCache();
      flags.current.dataLoaded=0;
      setState({...state, initialized: true, dataLoaded: 0, aircraftTrips:[], startDate, startTime, endTime});
    }
  }, [props.endDate, props.startDate, state])

  useLayoutEffect(()=> {
    const handleScrollEvent = (event) => {
      if (eventBus) {
        let scrollDirection = null;
        const lastScrollPosition = event.target.scrollLeft;
        const scrollLeft = lastScrollPosition;
        const previousScrollLeft = scrollState.current.lastScrollPosition||0;
        if (event.target.scrollLeft < scrollState.current.lastScrollPosition) {
          if ((scrollState.current.lastScrollPosition - event.target.scrollLeft) < 5000) {
            scrollDirection = "left";
          }
        }
        if (event.target.scrollLeft > scrollState.current.lastScrollPosition) {
          scrollDirection = "right";
        }
        scrollState.current = {lastScrollPosition, scrollDirection};
        //console.log('scrolling');
        eventBus.trigger('RouteView.scrolling', {previousScrollLeft, scrollLeft, scrollDirection});
      }
    }

    if (scrollRef && scrollRef.current && eventBus) {
      const parentRect = scrollRef.current.parentNode.getBoundingClientRect();
      const clientWidth = parentRect.width;
      const offset = clientWidth / 2;
      const scrollLeft = (state.blockSize/60) * (moment.utc().diff(moment.utc(props.startDate),'minute')) - (offset - 65);
//      const scrollLeft = (state.blockSize/60) * (moment().diff(moment.utc(props.startDate),'minute')) - offset;

      let stateChanges = {}
      if (state.scrollLeft < 0) {
        stateChanges['scrollLeft'] = scrollLeft;
      }

      if (clientWidth !== state.clientWidth) {
        stateChanges['clientWidth'] = clientWidth;
      }
      if (!flags.current.initialized) {
        // console.log('Initializing');
        scrollRef.current.addEventListener('scroll', handleScrollEvent.bind(this));
        flags.current['initialized'] = true;
      }
      if (Object.keys(stateChanges).length > 0) {
        console.log('layout Effect')
        setState({...state, ...stateChanges});
      }
  }

  },[eventBus, flags, props.startDate, scrollRef, state]);

  return (
    <RefreshCheck
      periodFrom={state.startTime}
      periodTo={state.endTime}
      refreshEventName="RouteView.autoRefresh"
      pauseEventName={["RouteView.pause", "RouteView.popupPause"]}
      checkType="Flight Planning"
    >
      <div style={{height: "100%"}}>
        <TimeWindow
          startTime={state.startTime}
          endTime={state.endTime}
          aircraftTrips={state.aircraftTrips}
          aircraftMx={state.aircraftMx}
          blockSize={blockSize}
          clientWidth={state.clientWidth}
          scrollRef={scrollRef}
          editing={props.editing}
          canChange={props.canChange}
          colours={colours}
          offsets={offsets}
          showOriginals={props.showOriginals}
          deltas={props.editing && scratchPads && scratchPads.data && Array.isArray(scratchPads.data) && scratchPads.data.length > 0 ? {...scratchPads.data[props.scratchPad||0].deltas}: emptyDelta}
          toolTipPinned={tooltipState}
          dragTimeUnit={props.dragTimeUnit}
          canViewDetails={props.canViewDetails}
          detailAsPanel={props.detailAsPanel}
          userClass={props.userClass}
          hiddenAircraft={props.hiddenAircraft}
          selectedTripLegKey={state.selectedTripLegKey}
        />
        <EditTripDialog
          classes={classes}
          source="FLIGHT PLANNING"
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          extraKeys={[]}
          handleUpdate={handleSaveTrip}
          formatChars={formatChars}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />
        <EditTripLegStdDialog
          classes={classes}
          source="FLIGHT PLANNING"
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          handleUpdateEvent="RouteView.TimeWindow.droppedTrip"
          formatChars={formatChars}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />
        <AddTripDialog
          classes={classes}
          source="FLIGHT PLANNING"
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />
        <EditScheduledTripPlanningDialog 
          classes={classes}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />
        <TripContextMenu style={{ color: theme.palette.primary.main }}/>
        <MxContextMenu style={{ color: theme.palette.primary.main  }}/>
        <AircraftFuelLogDialog
          onChange={handleFuelLogDialogChange}
          {...aircraftFuelLogDialogProps}
        />
        <EditServicesDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          handleUpdateFlight={handleSaveServices}
          formatChars={formatChars}
          classes={classes}
          extraKeys={[]}
          afterSave={()=>{eventBus.trigger("RouteView.refreshLeg")}}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />
        <EditCrewDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          handleUpdateFlight={handleUpdateTripLeg}
          formatChars={formatChars}
          classes={classes}
          extraKeys={[]}
          afterSave={()=>{eventBus.trigger("RouteView.refreshLeg")}}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />
        <EditPaxDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          handleUpdateFlight={handleUpdateTripLeg}
          formatChars={formatChars}
          classes={classes}
          extraKeys={[]}
          afterSave={()=>{eventBus.trigger("RouteView.refreshLeg")}}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />
        <EditCateringDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          formatChars={formatChars}
          classes={classes}
          extraKeys={[]}
          canEdit={canEdit}
          afterSave={()=>{eventBus.trigger("RouteView.refreshLeg")}}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />

        <EditCargoDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          classes={classes}
          afterSave={()=>{eventBus.trigger("RouteView.refreshLeg")}}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />


        <FuelPolicyDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          classes={classes}
          afterSave={()=>{eventBus.trigger("RouteView.refreshLeg")}}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />

        <EditUldStacksDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          classes={classes}
          afterSave={()=>{eventBus.trigger("RouteView.refreshLeg")}}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />

        <TripLegsActualWeightDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          classes={classes}
          afterSave={()=>{eventBus.trigger("RouteView.refreshLeg")}}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />

        <TripLegsNoteDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          classes={classes}
          afterSave={()=>{eventBus.trigger("RouteView.refreshLeg")}}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />

        <TripLegEventDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          classes={classes}
          afterSave={()=>{eventBus.trigger("RouteView.refreshLeg")}}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />

        <TripLegDiversionDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          classes={classes}
          afterSave={()=>{eventBus.trigger("RouteView.refreshLeg")}}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />

        <TripLegReturnToStandDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          classes={classes}
          afterSave={()=>{eventBus.trigger("RouteView.refreshLeg")}}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />

        <TripLegChecklistItemDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          classes={classes}
          afterSave={()=>{eventBus.trigger("RouteView.refreshLeg")}}
          onClose={()=>eventBus.trigger('RouteView.pause', false)}
        />

        <EditFlightDocumentsDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          extraKeys={[]}
          handleUpdateFlight={handleUpdateFlight}
          formatChars={formatChars}
          classes={classes}
          canEdit={true}
        />

        <ViewUldDocumentsDialog
          systemData={SystemData}
          apiSitePrefix={apiSitePrefix}
          eventPrefix="ViewUldDocuments"
          documentFilter={(documents) => __.filter(documents, (document) => {return uldDocuments.indexOf(document.documentType) >= 0})}
          extraKeys={[]}
          formatChars={formatChars}
          classes={classes}
          canEdit={false}
        />

        <EditFlightMessagesDialog
          classes={classes}
          systemData={SystemData}
          extraKeys={extraKeys}
          formatChars={formatChars}
          canEdit={state.canEdit}
        />

        <ViewUldMessagesDialog
          classes={classes}
          systemData={SystemData}
          extraKeys={extraKeys}
          formatChars={formatChars}
          canEdit={false}
          eventPrefix="ViewUldMessages"
          messageFilter={(messages) => __.filter(messages, (message) => { return (uldMessages.indexOf(message.messageType) >= 0 || uldMessages.indexOf(message.uwsSource) >= 0)})}
        />

        <ViewBooking />

        {captureMovementDialog.captureMovement && captureMovementDialog.aircraft
          ? <AircraftMovementCaptureDialog
            title={captureMovementDialog.tripLegUuid ? `Capture Movement for flight ${captureMovementDialog.airlineCode}-${captureMovementDialog.flightNo} (${captureMovementDialog.originAirportCode}-${captureMovementDialog.destinationAirportCode})` : `Capture Movement for Aircraft ${captureMovementDialog.aircraft}`}
            open={captureMovementDialog.captureMovement}
            aircraftTailNumber={captureMovementDialog.aircraft}
            airlineCode={captureMovementDialog.airlineCode}
            flightNo={captureMovementDialog.flightNo}
            originAirportCode={captureMovementDialog.originAirportCode}
            destinationAirportCode={captureMovementDialog.destinationAirportCode}
            tripLegUuid={captureMovementDialog.tripLegUuid}
            onChange={() => {
              setCaptureMovementDialog({
                captureMovement: false,
                aircraft: "",
                airlineCode: "",
                flightNo: "",
                originAirportCode: "",
                destinationAirportCode: ""
              });
              eventBus.trigger('RouteView.refreshLeg');
            }}
          />
          : null
        }
      </div>
    </RefreshCheck>
  );
}
export default memo(RouteView);
